/**
 * Redakční systém JSR
 * e_konfigurator.js
 * JQuery funkce pro stránku konfigurátoru e-shopu
 *
 * @package eshop
 *
 * @author Jakub Roček <jakub@skit.cz>
 * @copyright (c) 2007-2024 Josef Šmíd
 * @version 2.5.3
 */

$(document).ready(function ()
{
  /*https://github.com/VelociraptorCZE/MiniLazyload*/ 
  const lazyLoadInst = new MiniLazyload({
    rootMargin: "500px",
    threshold: .5,
    placeholder: "https://imgplaceholder.com/420x320/ff7f7f/333333/fa-image"
  }, ".lazyload" );

  $("#url_def").val(window.location.href);
  $("#url_title").val($(document).find("title").text());

  //odstranění přidávaného textu do url
  var newurl = $("#url_def").val();
  var newtitleurl = $("#url_title").val();

  if (newurl.indexOf("?") >= 0)
  {
    var after_url = newurl.split('?');
    $("#after_url").val('?' + after_url[1]);
    newurl = after_url[0];
  }

  var lastChar = newurl.substr(newurl.length - 1);
  if (lastChar === '/')
  {
    newurl = newurl.slice(0, -1);
  }

  if(newurl.indexOf($('#preset_produkt').val()) >= 0  && (newurl.indexOf('k1') >= 0 || newurl.indexOf('k2') >= 0))
  {
    newurl = newurl.replace('/' +$('#preset_produkt').val(), ''); 
  }  
  setCookie('prislusko_vyzkousene', '',0);
  setCookie('sluzby_vyzkousene', '',0);
 
//   console.log("0: " + newurl);
  $(".bar").each(function (index) {
    var dataurl = $('#bar_' + index).attr("data-url");
    newurl = newurl.replace('/' + dataurl, '');

    newtitleurl = newtitleurl.replace('/' + dataurl, '');
  });
//  newurl = newurl.replace('//', '/');
//  console.log("1: " + newurl);
  document.title = newtitleurl + "/" + $("#bar_0").attr("data-url");
  window.history.pushState({"html": $("#bar_0").attr("data-url"), "pageTitle": $("#url_title").val() + "/" + $("#bar_0").attr("data-url")}, "", newurl + '/' + $("#bar_" + $("#sekce").val()).attr("data-url") + "/" + $("#after_url").val());
  $("#url_def").val(newurl);
  $("#url_title").val(newtitleurl);
//  console.log("1: " + newurl);

  bar_seda();

  $('#form_koupit').submit(function ()
  {
    window.history.replaceState({}, document.title, "/" + "konfigurator/");
    console.log("repl: ");
    setCookie('save_konfigurator_auto', '',0);
    this.submit();
    return true;
  });

  //proměná kde jsou uložené data o krocích
  var data_vyber = $('#js_array').val();
  if (data_vyber)
  {

    var kroky = data_vyber.split(',');
    if ($('#preset_produkt').val() === '' || $('#preset_produkt').val().indexOf("k1_") < 0)
    {
      //vyberu první krok abych aktivoval správné vybery
      var vybery_prvni = kroky[0].split('_');
      var kat_preskoc = [];
      if (vybery_prvni[4])
      {
        kat_preskoc = vybery_prvni[4].split(':');
      }

      if (jQuery.inArray($('#js_kategorie_id').val(), kat_preskoc) < 0)
      {
        $.ajax({
          url: '/rsadmin/_funkce/eshop_dostupnost_produkty.php',
          type: "GET",
          dataType: "html",
          cache: false,
          data: {kod_produktu: $('#kod_zacatek_' + vybery_prvni[0]).val(), typ: 1, can_objednat: vybery_prvni[3], kategorie: $('#js_kategorie').val()},
          success: function (aData) {
            var result = JSON.parse(aData);
            aktivace_objednani_skryti(result, vybery_prvni[3]);
          }
        });
      }
    }

    var krok_kontrola = -1;
    $.each(kroky, function (key, value) {
      var vybery = value.split('_');

      //pokud se klikne na nějaký výber tak projde touto funkcí
      $('#vyber_select_' + vybery[0] + '_' + vybery[1] + ' input[type="radio"]').click(function () {
      
        var vybery_schovat = $('#vyber_select_' + vybery[0] + '_' + vybery[1]).children('div').children('.dalsi_vybery');
        if(vybery_schovat.length)
        {
          var aktula_vyber = $(this);
          vybery_schovat.each(function (key_vyberu ,obj_vyberu) {
            if($(obj_vyberu).attr("id") !== aktula_vyber.attr("data-produktpuv")+"_vybery")
            {
              $(obj_vyberu).slideUp("slow", function () {
                  $(obj_vyberu).css({"display": "none"});
              });
              if((aktula_vyber.attr("data-vypisvyber") !== 'true' && $(obj_vyberu).attr("data-ignore") !== 'true' && aktula_vyber.val()+"_vybery" !== $(obj_vyberu).attr("id")) || $('#js_odebrat_podvyber').val() === '1') 
              {  
                 var data_produktpuv = $(obj_vyberu).find('input:checked').attr("data-produktpuv");
                 $('#vyber_select_' + vybery[0] + '_' + vybery[1] + ' input[data-produktpuv="'+data_produktpuv+'"]').parent('label').parent('div').addClass('prislusko_hide');
                 $('#' + data_produktpuv).parent('label').parent('div').removeClass('prislusko_hide');
                 $(obj_vyberu).find('input:checked').prop('checked', false);
              }
            }
          });
        } 
        if($(this).attr("data-vypisvyber") === 'true' && $('#js_odebrat_podvyber').val() === '0')
        {
          if($("#"+$(this).attr("data-produktpuv")+"_vybery").is(":hidden"))
          {
            $("#"+$(this).attr("data-produktpuv")+"_vybery").slideDown("slow", function () {
            });
            $("#"+$(this).attr("data-produktpuv")+"_vybery").css({"display": "block"});
            return false;
          }
          else
          {
            $("#"+$(this).attr("data-produktpuv")+"_vybery").slideUp("slow", function () {
              $("#"+$(this).attr("data-produktpuv")+"_vybery").css({"display": "none"});
            });
          }
          if($(this).val() === $(this).attr("data-produktpuv") || $(this).val() === $('#kod_' + vybery[0] + '_' + vybery[1]).val())return false;
        }

        if($(this).parent('label').find(".selecty_parametry").length)
        {
          if($(this).parent('label').find(".selecty_parametry").is(":hidden"))
          {
            $(this).parent('label').find(".selecty_parametry").slideDown("slow", function () {  
            });
            $(this).parent('label').find(".selecty_parametry").css({"display": "block"});
            setMezeraProSluzbyDesek();
          }
          else
          {
            $(this).parent('label').find(".selecty_parametry").css({"display": "none"});
            if($(this).parent('label').find(".select_sluzba").length)
            {
              $.each($(this).parent('label').find(".select_sluzba"), function (key_param, value_param) {
                var selectet_option = $(value_param).find("option");
                $(value_param).val(selectet_option.val()); 
              });
            }
          } 
        }

        if($(this).attr("data-ignore") === 'true' || $('#js_odebrat_podvyber').val() === '1')
        {
          if($("#"+$(this).attr("data-produktpuv")+"_vybery").is(":visible") || $('#js_odebrat_podvyber').val() === '1')
          {
            $('#vyber_select_' + vybery[0] + '_' + vybery[1] + ' input[data-produktpuv="'+$(this).attr("data-produktpuv")+'"]').parent('label').parent('div').addClass('prislusko_hide');
            if($(this).val() === $('#kod_' + vybery[0] + '_' + vybery[1]).val())
            {
               $('#' + $(this).attr("data-produktpuv")).parent('label').parent('div').removeClass('prislusko_hide');
               $(this).prop('checked', false);
               $('#kod_' + vybery[0] + '_' + vybery[1]).val('');
            }  
            else
            {
              $('#' + $(this).val()).parent('label').parent('div').removeClass('prislusko_hide');            
            }     
            if($('#js_odebrat_podvyber').val() === '0')$('#' + $(this).val()).click();
          }
          if($('#js_odebrat_podvyber').val() === '0')return true; 
        }
        $('#js_odebrat_podvyber').val('0');
        
        if ($(this).val() === 'atyp')
        {
          if ($("#rozmer_kom").val() === '')
          {
            $("#zmena_velikosti").slideDown("slow", function () {

            });
            $("#zmena_velikosti").css({"display": "block"});
            return false;
          } else if ($("#open_atyp").val() == '0')
          {
            $("#zmena_velikosti").slideDown("slow", function () {

            });
            $("#zmena_velikosti").css({"display": "block"});
          }

        } else
        {
          $("#zmena_velikosti").slideUp("slow", function () {

          });
          $("#zmena_velikosti").css({"display": "none"});
          $(".canvas_div").hide();
        }
        $("#open_atyp").val('0');


        if (/*$('body').width() <= 1000*/ window.matchMedia('(max-width: 1000px)').matches)
        {

          if ($(this).val() === 'home_assembly')
          {
            if ($(this).parent('label').parent('div').hasClass("color_div_vyb"))
            {
            } else
            {
              if ($("#psc_sestavit_hod").val() === '')
              {
                $("#zmena_sestaveni").slideDown("slow", function () {

                });
                $("#zmena_sestaveni").css({"display": "table-row"});
                $('#pridat_' + $(this).val()).addClass('odebrat_label_ses');
                return false;
              } else if ($("#open_sestaveni").val() == '0')
              {
                $("#zmena_sestaveni").slideDown("slow", function () {

                });
                $("#zmena_sestaveni").css({"display": "table-row"});
                $('#pridat_' + $(this).val()).addClass('odebrat_label_ses');
              } else
              {
                $("#zmena_sestaveni").slideUp("slow", function () {

                });
                $("#zmena_sestaveni").css({"display": "none"});
                $('#pridat_' + $(this).val()).removeClass('odebrat_label_ses');
              }

            }

          } else
          {
            $("#zmena_sestaveni").slideUp("slow", function () {

            });
            $("#zmena_sestaveni").css({"display": "none"});
            $('#pridat_' + $(this).val()).removeClass('odebrat_label_ses');
          }
          $("#open_sestaveni").val('0');

          if ($(this).parent('label').parent('div').hasClass("color_div_vyb"))
          {
            $('#psc_sestavit_hod').val('');
            $('#pcs_sestaveni').val('');
          }
        }

//         alert($(this).parent('label').parent('div').hasClass("color_div_vyb"));
//        $('.prava_dodani').css('display', 'none');
        if (vybery[2] === 'prislusenstvi' && $(this).parent('label').parent('div').hasClass("color_div_vyb"))
        {

          $('#vyber_select_' + vybery[0] + '_' + vybery[1] + ' input[type="radio"]').prop('checked', false);
          $('#vyber_select_' + vybery[0] + '_' + vybery[1] + ' input[type="radio"]').parent('label').parent('div').removeClass("color_div_vyb");
          $('#bar_vybery_nevybrano_' + vybery[0] + '_' + vybery[1]).show();
          $('#bar_vybery_vybrano_' + vybery[0] + '_' + vybery[1]).hide();
          $('#vybrano_nadpis_' + vybery[0] + '_' + vybery[1]).empty();
          $('#kod_' + vybery[0] + '_' + vybery[1]).val('');
          zmen_cenu($('#cena_krok_' + vybery[0] + '_' + vybery[1]).val(), 0);
          $('#cena_krok_' + vybery[0] + '_' + vybery[1]).val('');
          cgangeimg(slider_bx);

        } else
        {
          $('#vyber_select_' + vybery[0] + '_' + vybery[1] + ' input[type="radio"]').parent('label').parent('div').removeClass('color_div_vyb');
          $(this).parent('label').parent('div').addClass('color_div_vyb');

          $('#kod_' + vybery[0] + '_' + vybery[1]).val($(this).val());
          $("#skiped_" + vybery[0]).val('false');
          $('#button_preskocit_' + vybery[0]).parent('label').parent('div').removeClass('color_div_vyb');
          $('#vybrano_nadpis_' + vybery[0] + '_' + vybery[1]).empty();
          $('#vybrano_nadpis_' + vybery[0] + '_' + vybery[1]).parent('h4').find('.dostupnost').remove();
          $('#vybrano_nadpis_' + vybery[0] + '_' + vybery[1]).append($(this).parent('label').find('.vybrano_nazev').val());
//        $('#vybrano_nadpis_' + vybery[0] + '_' + vybery[1]).parent('h4').append($(this).parent('label').find('.vybrano_dostupnost').val());

          $('#bar_vybery_nevybrano_' + vybery[0] + '_' + vybery[1]).hide();
          $('#bar_vybery_vybrano_' + vybery[0] + '_' + vybery[1]).show();


          //nastavím kod produktu, pro produkt ,který má více možností ho poskládám
          if ($('#kod_' + vybery[0]).val() !== '')
          {
            var novy_kod = '';
            if (vybery[2] === 'produkt')
            {
              novy_kod = $('#kod_zacatek_' + vybery[0]).val();
              var deaktivovat = 0;
              $.each(kroky, function (key_k, value_k) {
                var vybery_k = value_k.split('_');
                if (vybery[2] === 'produkt')
                {
                  if (vybery_k[0] === vybery[0])
                  {
                    if (deaktivovat === 1)
                    {
                      $('#kod_' + vybery_k[0] + '_' + vybery_k[1]).val('');
                    } else if ($("#vyber_select_" + vybery_k[0] + '_' + vybery_k[1]).is(":visible"))
                    {
                      novy_kod = novy_kod + "_" + $('#kod_' + vybery_k[0] + '_' + vybery_k[1]).val();
                    }
                    if (vybery_k[1] === vybery[1])
                    {
                      deaktivovat = 1;
                    }
                  }
                }
              });
            } 
//            else if (vybery[2] === 'prislusenstvi')
//            {
//              novy_kod = novy_kod + "_" + $(this).val();
//            }
            if(novy_kod)$('#kod_' + vybery[0]).val(novy_kod);
          } else
          {
            $('#kod_' + vybery[0]).val($('#kod_zacatek_' + vybery[0]).val() + "_" + $(this).val());
          }
          //pro komplet desky
          if ($('#kod_' + vybery[0]).val().indexOf("k2_k2_") >= 0)
          {
            $('#kod_' + vybery[0]).val($('#kod_' + vybery[0]).val().replace("k2_k2_", "k2_"));
          }

          var kod_produktu = $('#kod_' + vybery[0]).val();
          if (vybery[2] === 'produkt')
          {
            //deaktivace tlacitka pro pokracovani a přidání loading obrázku
            $('#button_dis_' + vybery[0]).val("true");
//          $("#eshop_obrazek").append('<img class="loading obr_loading" src="/images/loading.gif"/>');

            if (vybery[3] !== '')
              var can_objednat = vybery[3];
            else
              var can_objednat = '';

            //pokud se jedná o poslední výběr v kroku, načtu si data abych zjistil začátek kodu dálšího kroku
            var kroky_kod_old = kod_produktu.split('_');
            var count_kroky = 0;
            var count_kroky_vybrano = 0;
            var next_krok = '';
            var next_krok_can_objednat = '';

            $.each(kroky, function (key_kod, value_kod) {
              var vybery_kod = value_kod.split('_');
              if (vybery_kod[0] === vybery[0])
              {
                if (!$('#vyber_select_' + vybery_kod[0] + '_' + vybery_kod[1]).hasClass("kat_hidden_konf") && vybery_kod[2] === 'produkt')
                {
                  count_kroky = count_kroky + 1;

                }
              }
              if (vybery_kod[0] === vybery[0] && vybery_kod[2] === 'produkt')
              {

                next_krok_can_objednat = vybery_kod[3];

              }
              if (vybery_kod[0] > vybery[0] && vybery_kod[2] === 'produkt')
              {
                next_krok = $('#kod_zacatek_' + vybery_kod[0]).val();
                next_krok_can_objednat = vybery_kod[3];
                return;
              }
            });

            //pokud se jedná o poslední krok tak zjistím přesnou cenu vybraného produktu
            if (count_kroky <= kroky_kod_old.length - 1)
            {

              $.ajax({
                url: '/rsadmin/_funkce/eshop_dostupnost_produkty.php',
                type: "GET",
                dataType: "html",
                cache: false,
                data: {kod_produktu: $('#kod_' + vybery[0]).val(), typ: 3, kategorie: $('#js_kategorie').val(), vl: $("#rozmer_kom_vl").val()},
                success: function (aData) {
                  var result = JSON.parse(aData);
                  zmen_cenu($('#cena_krok_' + vybery[0]).val(), result.cena);
                  if ($('#cena_krok_' + vybery[0]).val(result.cena) === '')
                    $('#cena_krok_' + vybery[0]).val(result.cena);
                }
              });
              if (next_krok)
              {
                kod_produktu = next_krok;
                can_objednat = next_krok_can_objednat;
              }
              
             //služby desek pro poslední krok  
             var sluzby = "";
             $('#last_step_' + vybery[0]).val(vybery[0]+'_'+vybery[1]);
             var sluzby_podradi = parseFloat($(this).parent('label').parent('div').css('order'));
             var id_kat_sluzby = $('#kat_desky_' + vybery[0]).val();

             if($('#last_step_' + vybery[0]).val() !== vybery[0]+'_'+vybery[1] && vybery[0] == 1)$('.sluzby_desky_blok').css({"display": "none"});
         
              $.each(kroky, function (key_kod, value_kod) {
                var vybery_kod = value_kod.split('_');
                if(vybery_kod[0] === vybery[0] && vybery_kod[2] === 'produkt' && $('#vyber_select_' + vybery_kod[0] + '_' + vybery_kod[1]).is(":visible"))
                {
                  sluzby = "#sluzby_"+vybery_kod[0]+"_"+vybery_kod[1]+"";
                }
                if(vybery_kod[0] === vybery[0] && vybery_kod[2] === 'prislusenstvi')
                {
                  if($(sluzby).length > 0)
                  {  
                    $('#vyber_select_' + vybery_kod[0] + '_' + vybery_kod[1] +'').appendTo(sluzby);
                    $(sluzby).css('order', sluzby_podradi); 
                    $('.sluzby_hidden').removeClass("sluzby_hidden");


                    $(sluzby).slideDown("slow", function () {
                       $(sluzby).css({"display": "table"});
                    });

                    $('#vyber_select_' + vybery_kod[0] + '_' + vybery_kod[1] + ' input[type="radio"]').prop('checked', false);
                    $('#vyber_select_' + vybery_kod[0] + '_' + vybery_kod[1] + ' input[type="radio"]').parent('label').parent('div').removeClass("color_div_vyb");
                    if($('#vyber_select_' + vybery_kod[0] + '_' + vybery_kod[1] + ' input[type="radio"]').parent('label').find(".selecty_parametry").length)
                    {
                      if($('#vyber_select_' + vybery_kod[0] + '_' + vybery_kod[1] + ' input[type="radio"]').parent('label').find(".selecty_parametry").is(":hidden"))
                      {}
                      else 
                      {
                        $('#vyber_select_' + vybery_kod[0] + '_' + vybery_kod[1] + ' input[type="radio"]').parent('label').find(".selecty_parametry").css({"display": "none"});   
                      }
                      if($('#vyber_select_' + vybery_kod[0] + '_' + vybery_kod[1] + ' input[type="radio"]').parent('label').find(".select_sluzba").length)
                      {
                        $.each($('#vyber_select_' + vybery_kod[0] + '_' + vybery_kod[1] + ' input[type="radio"]').parent('label').find(".select_sluzba"), function (key_param, value_param) {
                          var selectet_option = $(value_param).find("option");
                          $(value_param).val(selectet_option.val()); 
                        });
                      }
                    }
                    if($('#cena_krok_' + vybery_kod[0] + '_' + vybery_kod[1]).val() > 0)
                    {
                      zmen_cenu($('#cena_krok_' + vybery_kod[0] + '_' + vybery_kod[1]).val(),0);
                      $('#cena_krok_' + vybery_kod[0] + '_' + vybery_kod[1]).val('0');
                    }

                    $('#vyber_select_' + vybery_kod[0] + '_' + vybery_kod[1] + ' input[type="radio"]').each(function (index, element) {
                      if (jQuery.inArray(id_kat_sluzby, $(element).attr('data-kategorie').split(',')) !== -1 || id_kat_sluzby === "")
                      {
                          $(element).parent('label').parent('div').removeClass('kat_hidden_konf');
                          $('#vyber_select_' + vybery_kod[0] + '_' + vybery_kod[1]).removeClass('kat_hidden_konf');
                          $(element).parent('label').parent('div').removeClass("color_div_nohover");
                          $(element).prop('disabled', false);
                      }
                    });
                    setMezeraProSluzbyDesek();
                  }
                }
              });
            }
            if ($('.ceny_' + vybery[0] + '_' + vybery[1]).val() === '1')
            {
              $.ajax({
                url: '/rsadmin/_funkce/eshop_dostupnost_produkty.php',
                type: "GET",
                dataType: "html",
                cache: false,
                data: {kod_produktu: $('#kod_' + vybery[0]).val(), typ: 3, kategorie: $('#js_kategorie').val(), vl: $("#rozmer_kom_vl").val()},
                success: function (aData) {
                  var result = JSON.parse(aData);
                  zmen_cenu($('#cena_krok_' + vybery[0]).val(), result.cena);

                  if ($('#cena_krok_' + vybery[0]).val(result.cena) === '')
                    $('#cena_krok_' + vybery[0]).val(result.cena);
                }
              });
            }

            var vsechny_kody = '';
            var vsechny_kody_krok = '';
            $.each(kroky, function (key_vse, value_vse) {
              var vybery_vse = value_vse.split('_');
              if (vybery_vse[2] === 'produkt' && vsechny_kody_krok !== vybery_vse[0])
              {
                if ($('#kod_' + vybery_vse[0]).val() !== '')
                {
                  vsechny_kody = vsechny_kody + $('#kod_' + vybery_vse[0]).val() + '|';
                }
                vsechny_kody_krok = vybery_vse[0];
              }
            });
            

            if($('#last_step_' + vybery[0]).val() !== vybery[0]+'_'+vybery[1] && vybery[0] == 1)
            {
             $(".sluzby_desky_blok").slideUp("slow", function () {
               $('.sluzby_desky_blok').css({"display": "none"});
             });
            }

            $.ajax({
              url: '/rsadmin/_funkce/eshop_dostupnost_produkty.php',
              type: "GET",
              dataType: "html",
              cache: false,

              data: {kod_produktu: kod_produktu, typ: 1, vsechny_kody: vsechny_kody, can_objednat: can_objednat, kategorie: $('#js_kategorie').val(), kat_desky: $('#kat_desky_' + vybery[0]).val(), vl: $("#rozmer_kom_vl").val()},
              success: function (aData) {

                if (aData)
                {

                  var result = JSON.parse(aData);
                  var deaktivovat_krok = 0;
                  var deaktivovat = 0;
                  var pocet_v_kroku = 0;
                  var jen_jednou = 0;
                  var akt_krok = 0;
                  $.each(kroky, function (key_d, value_d) {
                    var vybery_d = value_d.split('_');
                    if (vybery_d[2] === 'produkt')
                    {
                      if (vybery_d[0] > akt_krok)
                      {
                        akt_krok = vybery_d[0];
                        jen_jednou = 0;
                      }

                      if ((deaktivovat_krok === 1 && vybery_d[0] === vybery[0]) || deaktivovat === 1)
                      {
                        $('#kod_' + vybery_d[0]).val($('#kod_' + vybery_d[0]).val().replace('_' + $('input[name="' + vybery_d[0] + '_' + vybery_d[1] + '"]:checked').val(), ""));
                        $('input[name="' + vybery_d[0] + '_' + vybery_d[1] + '"]').prop("disabled", true);
                        $('input[name="' + vybery_d[0] + '_' + vybery_d[1] + '"]').prop('checked', false);
                        $('#vybrano_nadpis_' + vybery_d[0] + '_' + vybery_d[1]).empty();
                        $('#vybrano_nadpis_' + vybery_d[0] + '_' + vybery_d[1]).parent('h4').find('.dostupnost').remove();
                        $('input[name="' + vybery_d[0] + '_' + vybery_d[1] + '"]').parent('label').parent().find('.ceny_plus').empty();
                        $('input[name="' + vybery_d[0] + '_' + vybery_d[1] + '"]').parent('label').parent().find('.dostupnost').remove();
                        $('input[name="' + vybery_d[0] + '_' + vybery_d[1] + '"]').parent('label').parent().find('.cena_od').remove();
                        $('input[name="' + vybery_d[0] + '_' + vybery_d[1] + '"]').parent('label').parent('div').addClass("color_div_nohover");
                        $('input[name="' + vybery_d[0] + '_' + vybery_d[1] + '"]').parent('label').parent('div').removeClass("color_div_vyb");


                        $('#bar_vybery_nevybrano_' + vybery_d[0] + '_' + vybery_d[1]).show();
                        $('#bar_vybery_vybrano_' + vybery_d[0] + '_' + vybery_d[1]).hide();
                        if ($('.ceny_' + vybery[0] + '_' + vybery[1]).val() !== '1' && count_kroky > kroky_kod_old.length - 1)
                        {
                          zmen_cenu($('#cena_krok_' + vybery_d[0]).val(), 0);
                          $('#cena_krok_' + vybery_d[0]).val('0');
                        }
                        $('#kod_' + vybery_d[0] + '_' + vybery_d[1]).val('');

                        //pouze liftor

                        if (vsechny_kody.indexOf("_atyp") >= 0) {
                        } else
                        {
                          $("#rozmer_kom").val('');
                          $("#rozmer_kom_vl").val('');
                          $("#zmena_velikosti").slideUp("slow", function () {

                          });
//                      $("#zmena_velikosti").removeAttr('style');
                          $("#canvas_zobrazeni").hide();
                          $(".rozmer_vlozeny_vlastni").remove();
                          $(".rozmer_vlozeny_vlastni_br").remove();
                        }

                      } else if (deaktivovat_krok === 1 && vybery_d[0] > vybery[0] && count_kroky === pocet_v_kroku && jen_jednou === 0)
                      {
                        if (!$('#vyber_select_' + vybery_d[0] + '_' + vybery_d[1]).hasClass("kat_hidden_konf"))
                        {
                          jen_jednou = 1;

                          if ($('#kod_' + vybery_d[0] + '_' + vybery_d[1]).val() !== '')
                          {
                            if (jQuery.inArray($('#kod_' + vybery_d[0] + '_' + vybery_d[1]).val(), result.activate) !== -1 || jQuery.inArray($('#kod_' + vybery_d[0] + '_' + vybery_d[1]).val(), result.naobjednani) !== -1)
                            {
                              var kod_kontrola = $('#kod_zacatek_' + vybery_d[0]).val();
                              var deaktivovat_k = 0;
                              $.each(kroky, function (key_k, value_k) {
                                var vybery_k = value_k.split('_');

                                if (vybery_d[0] === vybery_k[0] && deaktivovat_k === 0)
                                {

                                  if ($('#kod_' + vybery_k[0] + '_' + vybery_k[1]).val() !== '')
                                  {
                                    var vsechny_kody_k = '';
                                    var vsechny_kody_krok_k = '';
                                    var next_krok_can_objednat_k = '';
                                    $.each(kroky, function (key_vse, value_vse) {
                                      var vybery_vse = value_vse.split('_');
                                      if (vybery_vse[2] === 'produkt' && vsechny_kody_krok_k !== vybery_vse[0])
                                      {
                                        if (vybery_vse[0] !== vybery_k[0])
                                        {
                                          if ($('#kod_' + vybery_vse[0]).val() !== '')
                                          {
                                            vsechny_kody_k = vsechny_kody_k + $('#kod_' + vybery_vse[0]).val() + '|';
                                          }
                                        } else
                                        {
                                          vsechny_kody_k = vsechny_kody_k + kod_kontrola + '|';
                                          next_krok_can_objednat_k = vybery_vse[3];
                                        }
                                        vsechny_kody_krok_k = vybery_vse[0];
                                      }
                                    });

                                    $.ajax({
                                      url: '/rsadmin/_funkce/eshop_dostupnost_produkty.php',
                                      type: "GET",
                                      dataType: "html",
                                      cache: false,
                                      async: false,
                                      data: {kod_produktu: kod_kontrola, typ: 1, vsechny_kody: vsechny_kody_k, can_objednat: next_krok_can_objednat_k, kategorie: $('#js_kategorie').val(), kat_desky: $('#kat_desky_' + vybery[0]).val(), vl: $("#rozmer_kom_vl").val()},
                                      success: function (aData) {
                                        var result_k = JSON.parse(aData);

                                        if (jQuery.inArray($('#kod_' + vybery_k[0] + '_' + vybery_k[1]).val(), result_k.activate) !== -1 || jQuery.inArray($('#kod_' + vybery_k[0] + '_' + vybery_k[1]).val(), result_k.naobjednani) !== -1)
                                        {
                                          kod_kontrola = kod_kontrola + '_' + $('#kod_' + vybery_k[0] + '_' + vybery_k[1]).val();


                                          aktivace_objednani_skryti(result_k, next_krok_can_objednat_k);
                                        } else
                                        {
                                          deaktivovat_k = 1;
                                        }
                                      }
                                    });
                                  }
                                } else if (vybery_d[0] === vybery_k[0])
                                {
                                  if($('input[name="' + vybery_k[0] + '_' + vybery_k[1] + '"]').attr("data-sluzby_desek") !== 'true')deaktivace_vyberu(vybery_k[0], vybery_k[1], vsechny_kody_k);
                                }
                              });
                            } else
                            {
                              deaktivace_vyberu(vybery_d[0], vybery_d[1]);
                              deaktivovat = 1;
                            }
                          } else
                          {
                            deaktivace_vyberu(vybery_d[0], vybery_d[1]);
                            deaktivovat = 1;

                          }
                        }
                      }
                      if (vybery_d[0] === vybery[0] && vybery_d[1] === vybery[1])
                      {
                        deaktivovat_krok = 1;

                      }
                      if (vybery_d[0] === vybery[0] && $('#kod_' + vybery_d[0] + '_' + vybery_d[1]).val() !== '')
                      {
                        pocet_v_kroku = pocet_v_kroku + 1;
                      }
                    } 
                    if(!$('input[name="' + vybery_d[0] + '_' + vybery_d[1] + '"]').parent('label').parent('div').hasClass("prislusko_hide"))
                    {
                      $('input[name="' + vybery_d[0] + '_' + vybery_d[1] + '"]').parent('label').parent('div').show();
                    }
                  });




                  vsechny_kody_krok = -1;
                  vsechny_kody = '';
                  count_kroky_vybrano = 0;
                  count_kroky = 0;
                  $.each(kroky, function (key_kod, value_kod) {
                    var vybery_kod = value_kod.split('_');
                    if (vybery_kod[0] == vybery[0])
                    {
                      if (!$('#vyber_select_' + vybery_kod[0] + '_' + vybery_kod[1]).hasClass("kat_hidden_konf"))
                      {
                        count_kroky = count_kroky + 1;
                        if ($('input[name="' + vybery_kod[0] + '_' + vybery_kod[1] + '"]').is(':checked'))
                        {
                          count_kroky_vybrano = count_kroky_vybrano + 1;
                        }
                      }
                    }

                    if (vybery_kod[2] == 'produkt' && vsechny_kody_krok != vybery_kod[0])
                    {
                      if ($('#kod_' + vybery_kod[0]).val() !== '')
                      {
                        vsechny_kody = vsechny_kody + $('#kod_' + vybery_kod[0]).val() + '|';
                      }
                      vsechny_kody_krok = vybery_kod[0];
                    }
                  });

                  if (count_kroky_vybrano == (count_kroky - 1))
                  {
                    $.ajax({
                      url: '/rsadmin/_funkce/eshop_dostupnost_produkty.php',
                      type: "GET",
                      dataType: "html",
                      cache: false,
                      async: false,
                      data: {kod_produktu: kod_produktu, typ: 1, vsechny_kody: vsechny_kody, can_objednat: next_krok_can_objednat, kategorie: $('#js_kategorie').val(), produkt_existuje: true, kat_desky: $('#kat_desky_' + vybery[0]).val(), vl: $("#rozmer_kom_vl").val()},
                      success: function (aData) {
                        var result_k = JSON.parse(aData);

                        aktivace_objednani_skryti(result_k, can_objednat);

                      }
                    });
                  } else
                  {
                    aktivace_objednani_skryti(result, can_objednat);
                  }

                }
                setMezeraProSluzbyDesek();
                $('#button_dis_' + vybery[0]).val("false");
                cgangeimg(slider_bx);

                var kontrola_ch = [];
                $.each(kroky, function (key_k, value_k) {
                  var vybery_k = value_k.split('_');
                  if (vybery[0] === vybery_k[0])
                  {
                    if($("#vyber_select_" + vybery_k[0] + '_' + vybery_k[1]).is(":visible"))
                    {  
                      if ($('input[name="' + vybery_k[0] + '_' + vybery_k[1] + '"]').is(':checked'))
                      {
                        if ($('input[name="' + vybery_k[0] + '_' + vybery_k[1] + '"]:checked').val() === 'atyp')
                        {
                          if ($("#rozmer_kom").val() !== '')
                            kontrola_ch[key_k] = "1";
                          else
                          {
                            kontrola_ch[key_k] = "0";
                          }
                        } else
                          kontrola_ch[key_k] = "1";
                      } else
                      {
                        kontrola_ch[key_k] = "0";
                      }
                    }
                  }
                });
                
                if ((jQuery.inArray("0", kontrola_ch) === -1 || $("#skiped_" + vybery[0]).val() === 'true'))
                {
                  $("#chyba_" + vybery[0]).hide();
                }

              }
            });
            if ($('.ceny_' + vybery[0] + '_' + vybery[1]).val() == '1')
            {
              upravcenypodlevybraneho(vybery[0], vybery[1], $(this).val());
            }

            $('#chyba_' + vybery[0] + '_' + vybery[1]).hide();

          } else if (vybery[2] === 'prislusenstvi')
          {
            var cena_dr_n = 0;
            var cena_dr_s = 0;

            if ($(this)[0].hasAttribute("data-cena"))
            {
              cena_dr_n = $(this).attr("data-cena");
            } else
              cena_dr_n = 0;

            if ($('#cena_krok_' + vybery[0] + '_' + vybery[1]).val() !== '')
            {
              cena_dr_s = $('#cena_krok_' + vybery[0] + '_' + vybery[1]).val();
            }
            if ($('#cena_krok_' + vybery[0] + '_' + vybery[1]).val() === '' || $('#cena_krok_' + vybery[0] + '_' + vybery[1]).val() !== cena_dr_n)
            {
              $('#cena_krok_' + vybery[0] + '_' + vybery[1]).val(cena_dr_n);
            }
            zmen_cenu(cena_dr_s, cena_dr_n);
            cgangeimg(slider_bx);
            if($('input[name="' + vybery[0] + '_' + vybery[1] + '"]').attr('data-typproduktu') === 'prislusenstvi')
            {
              if(getCookie('prislusko_vyzkousene'))
              {
                if (jQuery.inArray($('#kod_' + vybery[0] + '_' + vybery[1]).val(), getCookie('prislusko_vyzkousene').split('|')) === -1 )setCookie('prislusko_vyzkousene', getCookie('prislusko_vyzkousene') + '|' + $('#kod_' + vybery[0] + '_' + vybery[1]).val(),1);   
              }
              else setCookie('prislusko_vyzkousene',$('#kod_' + vybery[0] + '_' + vybery[1]).val(),1); 
            }
            else if($('input[name="' + vybery[0] + '_' + vybery[1] + '"]').attr('data-typproduktu') === 'sluzby')
            {
              if(getCookie('sluzby_vyzkousene'))
              {
                if (jQuery.inArray($('#kod_' + vybery[0] + '_' + vybery[1]).val(), getCookie('sluzby_vyzkousene').split('|')) === -1 )setCookie('sluzby_vyzkousene', getCookie('sluzby_vyzkousene') + '|' + $('#kod_' + vybery[0] + '_' + vybery[1]).val(),1);   
              }
              else setCookie('sluzby_vyzkousene',$('#kod_' + vybery[0] + '_' + vybery[1]).val(),1); 
            }
          }
          
//          if ($('.popis_produktu_konf').length > 0)nastavPopis();  
          if($('input[name="' + vybery[0] + '_' + vybery[1] + '"]').parent('label').parent('div').hasClass("color_div_mal") && ($('.popis_produktu_konf').length > 0 || $('.popis_produktu_konf').html() !== ''))nastavPopis();
          sdileni_ulozeny();
        }
        dodani_vypis();
      });


      if (krok_kontrola != vybery[0])
      {
        krok_kontrola = vybery[0];
        $('.button_pokracovat_' + vybery[0]).click(function () {
          var pokracovat = 0;
          var kontrola = [];
          var last_krok = 0;
          var hlavni_chyba = 0;
          $.each(kroky, function (key_k, value_k) {
            var vybery_k = value_k.split('_');
            if (vybery[0] === vybery_k[0])
            {
              if ($("#vyber_select_" + vybery_k[0] + '_' + vybery_k[1]).is(":visible"))
              {
                if ($('input[name="' + vybery_k[0] + '_' + vybery_k[1] + '"]').is(':checked') || $('.nevybrano_' + vybery_k[0] + '_' + vybery_k[1] + '').val() == 'true' || $("#skiped_" + vybery[0]).val() === 'true')
                {
                  if ($('input[name="' + vybery_k[0] + '_' + vybery_k[1] + '"]:checked').val() === 'atyp')
                  {
                    if ($("#rozmer_kom").val() !== '')
                      kontrola[key_k] = "1";
                    else
                    {
                      kontrola[key_k] = "0";
                      $("#chyba_" + vybery_k[0] + '_' + vybery_k[1]).show();
                      if (hlavni_chyba == 0)
                      {
                        if($("#vyber_select_" + vybery_k[0] + '_' + vybery_k[1]).length)
                        {
                          $('html, body').animate({
                            scrollTop: $("#vyber_select_" + vybery_k[0] + '_' + vybery_k[1]).offset().top
                          }, 500);
                        }
                        hlavni_chyba = 1;
                      }
                      //                    $("#chyba_" + vybery_k[0]).insertBefore("#chyba_" + vybery_k[0]+'_'+vybery_k[1]);
                      $("#chyba_" + vybery_k[0]).show();
                    }
                  } else
                    kontrola[key_k] = "1";
                } else
                {
                  kontrola[key_k] = "0";
                  $("#chyba_" + vybery_k[0] + '_' + vybery_k[1]).show();
                  if (hlavni_chyba == 0)
                  {
                    if($("#vyber_select_" + vybery_k[0] + '_' + vybery_k[1]).length)
                    {
                      $('html, body').animate({
                        scrollTop: $("#vyber_select_" + vybery_k[0] + '_' + vybery_k[1]).offset().top
                      }, 500);
                    }
                    hlavni_chyba = 1;
                  }
                  //                $("#chyba_" + vybery_k[0]).insertBefore("#chyba_" + vybery_k[0]+'_'+vybery_k[1]);
                  $("#chyba_" + vybery_k[0]).show();
                }
              }
            }
            last_krok = vybery_k[0];

          });

          if ((jQuery.inArray("0", kontrola) === -1 || $("#skiped_" + vybery[0]).val() === 'true') && $('#button_dis_' + vybery[0]).val() === 'false')
          {
            pokracovat = 1;
          }
          if ($('#zadat_sn_' + vybery[0]).val() == 'true')
          {
            var produtk_sn = '';
            if ($('#kod_' + vybery[0]).val() != '')
            {
              if ($('#' + $('#kod_' + vybery[0]).val()).length)
              {
                if (typeof $('#' + $('#kod_' + vybery[0]).val()).attr("data-sn") !== typeof undefined && $(this).attr("data-sn") !== false) {

                  produtk_sn = $('#' + $('#kod_' + vybery[0]).val()).attr("data-sn");
                  $('#mnozstvi_konf').val('1');
                  $('#mnozstvi_konf').prop("disabled", true);
                  $('.vlozit_kosik_stred_leva').hide();
                } else
                {
                  $('#mnozstvi_konf').val('1');
                  $('#mnozstvi_konf').prop("disabled", false);
                  $('.vlozit_kosik_stred_leva').show();
                }
              } else
              {
                $('#mnozstvi_konf').val('1');
                $('#mnozstvi_konf').prop("disabled", false);
                $('.vlozit_kosik_stred_leva').show();
              }
            } else
            {
              $('#mnozstvi_konf').val('1');
              $('#mnozstvi_konf').prop("disabled", false);
              $('.vlozit_kosik_stred_leva').show();
            }
//            if(produtk_sn)
//            {
            $.ajax({
              url: '/rsadmin/_funkce/eshop_dostupnost_produkty.php',
              type: "GET",
              async: false,
              dataType: "html",
              cache: false,
              data: {kod_produktu: $('#kod_' + vybery[0]).val(), typ: 8, kategorie: $('#js_kategorie').val(), produktsn: produtk_sn, krok: vybery[0]},
              success: function (aData) {
                var result = JSON.parse(aData);
                if (result.rezervace.vysledek == false)
                {
                  $("#js_rezervace_odpocet").val('');
                  $("#js_rezervace_id").val('');
                  $("#js_rezervace_krok").val('');
                  pokracovat = 0;
                } else if (result.rezervace.vysledek == true && result.rezervace.time && result.rezervace.id)
                {
                  $("#js_rezervace_odpocet").val(result.rezervace.time);
                  $("#js_rezervace_id").val(result.rezervace.id);
                  $("#js_rezervace_krok").val(vybery[0]);
                } else if (result.rezervace.vysledek == true)
                {
                  $("#js_rezervace_odpocet").val('');
                  $("#js_rezervace_id").val('');
                  $("#js_rezervace_krok").val('');
                }
              }
            });
//            }
          }
          if (pokracovat === 1)
          {

            var dalsi = parseInt(vybery[0]) + parseInt(1);

            $(".chyba").hide();
            $(".canvas_div").hide();
            $("#zmena_sestaveni").css({"display": "none"});
            $("#zmena_velikosti").css({"display": "none"});
            $('.pridat_label').removeClass('odebrat_label_ses');
            
            vypis_souhrnu_prubezne();
            $("#skladani_stolu_sekce_" + vybery[0]).hide();
            $("#skladani_stolu_sekce_" + dalsi).show();
            $("#sekce").val(dalsi);
            bar_seda();

            if (last_krok === vybery[0])
            {
//              $("#eshop_obrazek").append('<img class="loading obr_loading" src="/images/loading.gif"/>');
              var produkty_pridat = '';
              var produkty_recap = '';
              var vel = null;
              var jenjednou = -1;
              $.each(kroky, function (key_kosik, value_kosik) {
                var vybery_kosik = value_kosik.split('_');

                if ($("#skiped_" + vybery_kosik[0]).val() === 'true')
                {
                } else
                {
                  //vložení do košíku
                  if (vybery_kosik[2] === 'produkt')
                  {

                    if ($('#kod_' + vybery_kosik[0]).val() !== '' && jenjednou !== vybery_kosik[0])
                    {
                      jenjednou = vybery_kosik[0];
                      if ($('#kod_' + vybery_kosik[0]).val().indexOf("_atyp") >= 0)vel = $("#rozmer_kom").val();
                      if (produkty_pridat !== '')produkty_pridat = produkty_pridat + '|';
                      produkty_pridat = produkty_pridat + $('#kod_' + vybery_kosik[0]).val();
                    }
                  } else if (vybery_kosik[2] === 'prislusenstvi')
                  {
                    if ($('#kod_' + vybery_kosik[0] + '_' + vybery_kosik[1]).val() !== '')
                    {
                      if (produkty_pridat !== '')produkty_pridat = produkty_pridat + '|';
                      produkty_pridat = produkty_pridat + $('#kod_' + vybery_kosik[0] + '_' + vybery_kosik[1]).val();
                      if($('#'+$('#kod_' + vybery_kosik[0] + '_' + vybery_kosik[1]).val()).parent('label').find(".select_sluzba").length)
                      {
                        $.each($('#'+$('#kod_' + vybery_kosik[0] + '_' + vybery_kosik[1]).val()).parent('label').find(".select_sluzba"), function (key_param, value_param) {
                          produkty_pridat = produkty_pridat + '-'+ $(this).find(":selected").val();
                          if($(this).find(":selected").attr('data-produkt') === 'true')produkty_pridat = produkty_pridat + ';true';
                        });
                      }
                    }
                  }


                  if ($('#kod_' + vybery_kosik[0] + '_' + vybery_kosik[1]).val() === '')
                  {
                    //                    produkty_recap = produkty_recap + vybery_kosik[1] + ',' + 'none';
                  } else
                  {

                    produkty_recap = produkty_recap + vybery_kosik[1] + ',' + $('#kod_' + vybery_kosik[0] + '_' + vybery_kosik[1]).val();
                    if($('#'+$('#kod_' + vybery_kosik[0] + '_' + vybery_kosik[1]).val()).parent('label').find(".select_sluzba").length)
                    {
                      $.each($('#'+$('#kod_' + vybery_kosik[0] + '_' + vybery_kosik[1]).val()).parent('label').find(".select_sluzba"), function (key_param, value_param) {
                        produkty_recap = produkty_recap + '-'+ $(this).find(":selected").val();
                        if($(this).find(":selected").attr('data-produkt') === 'true')produkty_recap = produkty_recap + ';true';
                      });
                    }
                    produkty_recap = produkty_recap + '|';
                  }

                }
              });
              $('#konf_produkty').val(produkty_pridat);


              $.ajax({
                url: '/rsadmin/_funkce/eshop_dostupnost_produkty.php',
                type: "GET",
                dataType: "html",
                cache: false,
                data: {kod_produktu: produkty_recap, typ: 4, vel: vel, kategorie: $('#js_kategorie').val()},
                success: function (aData) {
                  var result = JSON.parse(aData);
                  $('.kontrola').remove();
                  $('#recapitulace').after(result.recapitulace);
                  cgangeimg(slider_bx);

                }
              });
              nacti_doporucene();
              if( $( ".vlozit_kosik_splatky" ).length > 0 )
              {
                if( parseInt( $( "#cena_h" ).val() ) < parseInt( $( ".vlozit_kosik_splatky" ).attr( "data-min" ) ) )
                {
                  $( ".vlozit_kosik_splatky" ).hide();
                }
                else
                {
                  $( ".vlozit_kosik_splatky" ).show();
                  var cena = parseInt( $( "#cena_h" ).val() ) / 10;
                  $( ".vlozit_kosik_splatky .kosik_splatky_span span" ).html( $( ".vlozit_kosik_splatky .kosik_splatky_span" ).attr( "data-text" ) + Math.round( cena ) + $( "#mena_za" ).val() );
                }
              }
            }            
            $("html,body").animate({ scrollTop: 0 });
          }

          if (slider_bx)
            slider_bx.goToSlide(0);

          if ($('#kategorie_' + dalsi).length)
          {
            if (($('#kod_' + dalsi).val() === '' || $('#kod_' + dalsi).val() === 'k2') && $("#skiped_" + dalsi).val() === 'false')
            {
              $('#kategorie_' + dalsi).find('input[type=radio]').filter(':visible:first').click();
            }
          }
          if ($('#preskoc_pokud_' + dalsi).length > 0)
          {
            var vybery_skip = $('#preskoc_pokud_' + dalsi).val().split(':');
            if (jQuery.inArray("" + $('#kod_' + $(this).attr("data-krok")).val() + "", vybery_skip) !== -1)
            {
              $('#button_preskocit_' + dalsi).click();
              $('.button_pokracovat_' + dalsi).click();
            }
            else if ($('#kategorie_' + dalsi).length)
            {
              if (($('#kod_' + dalsi).val() === '' || $('#kod_' + dalsi).val() === 'k2'))
              {
                $('#kategorie_' + dalsi).find('input[type=radio]').filter(':visible:first').click();
              }
            }
          }
            PrisluskoNavaznost();
        });


        $('#kategorie_' + vybery[0] + ' input[type="radio"]').click(function () {

          var id_kat = $(this).val();
          $('#kat_desky_' + vybery[0]).val(id_kat);
          var pocet_zobrazeno = 0;
          $.each($('#js_array').val().split(','), function (key_k, value_k) {

            var vybery_k = value_k.split('_');

            if (vybery_k[0] === vybery[0])
            {
              $('#vyber_select_' + vybery_k[0] + '_' + vybery_k[1]).removeClass('kat_hidden_konf');

              if ($('#vyber_select_' + vybery_k[0] + '_' + vybery_k[1]).find('#button_preskocit_' + vybery_k[0]).length)
              {
              } else
              {
                $('input[name="' + vybery_k[0] + '_' + vybery_k[1] + '"]').each(function (index, element) {

                  $(element).parent('label').parent('div').removeClass('kat_hidden_konf');
                  if (jQuery.inArray(id_kat, $(element).attr('data-kategorie').split(',')) !== -1)
                  {
                    pocet_zobrazeno = pocet_zobrazeno + 1;
                  } else
                  {
                    $(element).parent('label').parent('div').addClass('kat_hidden_konf');
                  }

                });
              }
            }
          });
          $.each($('#js_array').val().split(','), function (key_k, value_k) {
            var vybery_k = value_k.split('_');

            if (vybery_k[0] === vybery[0])
            {
              if($('input[name="' + vybery_k[0] + '_' + vybery_k[1] + '"]:visible').length == 0)
              {
                $('#vyber_select_' + vybery_k[0] + '_' + vybery_k[1]).addClass('kat_hidden_konf');
              }
            }
          });



          var krok = 0;
          var visible_vyber = 0;
          $.each(kroky, function (key_skip, value_skip) {
            var vybery_kat = value_skip.split('_');
            if (vybery_kat[0] === vybery[0])
            {
              if ($('#vyber_select_' + vybery_kat[0] + '_' + vybery_kat[1]).is(":visible"))
              {
                visible_vyber = visible_vyber + 1;
              }
              if (visible_vyber === 1)
              {
                $('input[name="' + vybery_kat[0] + '_' + vybery_kat[1] + '"]').prop('checked', false);
                $('input[name="' + vybery_kat[0] + '_' + vybery_kat[1] + '"]').prop("disabled", true);
                $('input[name="' + vybery_kat[0] + '_' + vybery_kat[1] + '"]').parent('label').parent('div').removeClass("color_div_vyb");
                $('input[name="' + vybery_kat[0] + '_' + vybery_kat[1] + '"]').parent('label').parent('div').addClass("color_div_nohover");
                $('input[name="' + vybery_kat[0] + '_' + vybery_kat[1] + '"]').parent('label').parent('div').css("display", "table");
                $('#bar_vybery_nevybrano_' + vybery_kat[0] + '_' + vybery_kat[1]).show();
                $('#bar_vybery_vybrano_' + vybery_kat[0] + '_' + vybery_kat[1]).hide();
                $('#vybrano_nadpis_' + vybery_kat[0] + '_' + vybery_kat[1]).empty();
              } else if (vybery_kat[2] === 'produkt')
              {
                $('input[name="' + vybery_kat[0] + '_' + vybery_kat[1] + '"]').prop("disabled", true);
                $('input[name="' + vybery_kat[0] + '_' + vybery_kat[1] + '"]').prop('checked', false);
                $('#vybrano_nadpis_' + vybery_kat[0] + '_' + vybery_kat[1]).empty();
                $('#vybrano_nadpis_' + vybery_kat[0] + '_' + vybery_kat[1]).parent('h4').find('.dostupnost').remove();
                $('input[name="' + vybery_kat[0] + '_' + vybery_kat[1] + '"]').parent('label').parent().find('.ceny_plus').empty();
                $('input[name="' + vybery_kat[0] + '_' + vybery_kat[1] + '"]').parent('label').parent().find('.cena_od').remove();
                $('input[name="' + vybery_kat[0] + '_' + vybery_kat[1] + '"]').parent('label').parent().find('.dostupnost').remove();
                $('input[name="' + vybery_kat[0] + '_' + vybery_kat[1] + '"]').parent('label').parent('div').addClass("color_div_nohover");
                $('input[name="' + vybery_kat[0] + '_' + vybery_kat[1] + '"]').parent('label').parent('div').removeClass("color_div_vyb");
                $('input[name="' + vybery_kat[0] + '_' + vybery_kat[1] + '"]').parent('label').parent('div').css("display", "table");

                $('#bar_vybery_nevybrano_' + vybery_kat[0] + '_' + vybery_kat[1]).show();
                $('#bar_vybery_vybrano_' + vybery_kat[0] + '_' + vybery_kat[1]).hide();
              } else if (vybery_kat[2] === 'prislusenstvi')
              {
                $('.sluzby_desky_blok').css({"display": "none"});
                $('input[name="' + vybery_kat[0] + '_' + vybery_kat[1] + '"]').prop("disabled", false);
                $('input[name="' + vybery_kat[0] + '_' + vybery_kat[1] + '"]').prop('checked', false);
                $('input[name="' + vybery_kat[0] + '_' + vybery_kat[1] + '"]').parent('label').parent('div').removeClass("color_div_nohover");
                $('input[name="' + vybery_kat[0] + '_' + vybery_kat[1] + '"]').parent('label').parent('div').removeClass("color_div_vyb");
                $('input[name="' + vybery_kat[0] + '_' + vybery_kat[1] + '"]').parent('label').parent('div').css("display", "table");
              }

              var cena_dr_n = 0;
              var cena_dr_s = 0;
              if ($('#cena_krok_' + vybery_kat[0] + '_' + vybery_kat[1]).val() > 0 && typeof $('#cena_krok_' + vybery_kat[0] + '_' + vybery_kat[1]).val() !== "undefined")
              {
                cena_dr_s = $('#cena_krok_' + vybery_kat[0] + '_' + vybery_kat[1]).val();
                $('#cena_krok_' + vybery_kat[0] + '_' + vybery_kat[1]).val(cena_dr_n);

              } else if ($('#cena_krok_' + vybery_kat[0]).val() > 0 && typeof $('#cena_krok_' + vybery_kat[0]).val() !== "undefined")
              {
                cena_dr_s = $('#cena_krok_' + vybery_kat[0]).val();
                $('#cena_krok_' + vybery_kat[0]).val(cena_dr_n);

              }
              zmen_cenu(cena_dr_s, cena_dr_n);
              $('#kod_' + vybery_kat[0] + '_' + vybery_kat[1]).val('');
              $('#kod_' + vybery_kat[0]).val('');
              //pouze liftor
              $("#rozmer_kom").val('');
              $("#rozmer_kom_vl").val('');
              $("#zmena_velikosti").slideUp("slow", function () {

              });

              $("#canvas_zobrazeni").hide();

              $('#chyba_' + vybery_kat[0] + '_' + vybery_kat[1]).hide();
              $('#chyba_' + vybery_kat[0]).hide();
              krok = krok + 1;

            }
          });
       
          var vsechny_kody = '';
          var vsechny_kody_krok = '';
          $.each(kroky, function (key_vse, value_vse) {
            var vybery_vse = value_vse.split('_');
            if (vybery_vse[2] == 'produkt' && vsechny_kody_krok != vybery_vse[0])
            {
              if ($('#kod_' + vybery_vse[0]).val() !== '')
              {
                vsechny_kody = vsechny_kody + $('#kod_' + vybery_vse[0]).val() + '|';
              } else
              {
                vsechny_kody = vsechny_kody + $('#kod_zacatek_' + vybery[0]).val() + '|';
              }
              vsechny_kody_krok = vybery_vse[0];
            }
          });
          var produkt_existuje = '';
          if (pocet_zobrazeno === 1)
          {
            produkt_existuje = true;
          }
          var can_objednat = vybery[3];
          var kod_kontrola = $('#kod_zacatek_' + vybery[0]).val();
          $.ajax({
            url: '/rsadmin/_funkce/eshop_dostupnost_produkty.php',
            type: "GET",
            dataType: "html",
            cache: false,
            async: false,
            data: {kod_produktu: kod_kontrola, typ: 1, vsechny_kody: vsechny_kody, can_objednat: can_objednat, kategorie: $('#js_kategorie').val(), produkt_existuje: produkt_existuje, kat_desky: id_kat, vl: $("#rozmer_kom_vl").val()},
            success: function (aData) {
              var result = JSON.parse(aData);

              if (result.activate)
              {
                $.each(result.activate, function (key_d, value) {
                  if (value !== '' && $('#' + value).length > 0 && $('#' + value).parent('label').parent('div').is(":visible"))
                  {
                    $('#' + value).parent().find('.dostupnost').remove();
                    $('#' + value).parent('label').parent('div').removeClass("color_div_nohover");
                    $('#' + value).prop("disabled", false);
                    if (can_objednat == 'true' && value in result.dodani)
                    {
                      if ($('#' + value).parent().find('.rozmer_vlozeny_vlastni').length) {
                        $('#' + value).parent().find('.rozmer_vlozeny_vlastni').after("<span class='dostupnost'><p>" + result.dodani[value] + "</p></span>");
                      } else
                        $('#' + value).parent().find('.vyber_nazev_js').after("<span class='dostupnost'><p>" + result.dodani[value] + "</p></span>");

                      $('#' + value).parent().find('.vybrano_dostupnost').val("<span class='dostupnost'><p>" + result.dodani[value] + "</p></span>");
                    }
                  }
                });
              }
              if (result.naobjednani)
              {
                $.each(result.naobjednani, function (key_d, value) {
                  if (value !== '' && $('#' + value).length > 0 && $('#' + value).parent('label').parent('div').is(":visible"))
                  {
                    $('#' + value).parent().find('.dostupnost').remove();
                    $('#' + value).parent('label').parent('div').removeClass("color_div_nohover");
                    $('#' + value).prop("disabled", false);
                    if (can_objednat == 'true' && value in result.dodani)
                    {
                      if ($('#' + value).parent().find('.rozmer_vlozeny_vlastni').length) {
                        $('#' + value).parent().find('.rozmer_vlozeny_vlastni').after("<span class='dostupnost oranzova'><p>" + result.dodani[value] + "</p></span>");
                      } else
                        $('#' + value).parent().find('.vyber_nazev_js').after("<span class='dostupnost oranzova'><p>" + result.dodani[value] + "</p></span>");

                      $('#' + value).parent().find('.vybrano_dostupnost').val("<span class='dostupnost oranzova'><p>" + result.dodani[value] + "</p></span>");
                    }
                  }
                });
              }
              if (result.skryt)
              {
                $.each(result.skryt, function (key_d, value) {
                  if (value !== '' && $('#' + value).length > 0)
                  {
                    $('#' + value).prop("checked", false);
                    $('#' + value).parent('label').parent('div').hide();
                    $('#' + value).parent('label').parent('div').removeClass("color_div_vyb");
                  }
                });
              }
              if (result.cena_od)
              {
                $.each(result.cena_od, function (key_d, value) {
                  if (value !== '' && $('#' + key_d).length > 0 && $('#' + key_d).parent('label').parent('div').is(":visible"))
                  {

                    $('#' + key_d).parent().find('.cena_od').remove();
                    if (value.old_cena)
                      $('#' + key_d).parent().find('.vyber_nazev_js').after("<span class='cena_od'><del>" + value.old_cena + "</del> " + value.cena + "</span>");
                    else
                      $('#' + key_d).parent().find('.vyber_nazev_js').after("<span class='cena_od'>" + value.cena + "</span>");

                  }
                });
              }

            }
          });

          cgangeimg(slider_bx);
          $("#skiped_" + vybery[0]).val('false');
          $('#kategorie_' + vybery[0]).find('.color_div_vyb').removeClass('color_div_vyb');
          $('#button_preskocit_' + vybery[0]).parent('label').parent('div').removeClass('color_div_vyb');
          $(this).parent('label').parent('div').addClass('color_div_vyb');
          dodani_vypis();
          preskocit_na_souhrn();
          sdileni_ulozeny();
        });

        $('#button_preskocit_' + vybery[0]).click(function () {
          if ($('#kategorie_' + vybery[0]).length)
          {
            var id_kat = 9999999999999;
            $.each($('#js_array').val().split(','), function (key_k, value_k) {

              var vybery_k = value_k.split('_');

              if (vybery_k[0] === vybery[0])
              {
                $('#vyber_select_' + vybery_k[0] + '_' + vybery_k[1]).removeClass('kat_hidden_konf');

                if ($('#vyber_select_' + vybery_k[0] + '_' + vybery_k[1]).find('#button_preskocit_' + vybery_k[0]).length)
                {
                } else
                {
                  $('input[name="' + vybery_k[0] + '_' + vybery_k[1] + '"]').each(function (index, element) {

                    $(element).parent('label').parent('div').removeClass('kat_hidden_konf');
                    if (jQuery.inArray(id_kat, $(element).attr('data-kategorie').split(',')) !== -1)
                    {

                    } else
                    {
                      $(element).parent('label').parent('div').addClass('kat_hidden_konf');
                    }
                    if($('input[name="' + vybery_k[0] + '_' + vybery_k[1] + '"]:visible').length == 0)
                    {
                      $('#vyber_select_' + vybery_k[0] + '_' + vybery_k[1]).addClass('kat_hidden_konf');
                    }
                  });
                }
              }
            });
          }
          var krok = 0;
          var visible_vyber = 0;
          $.each(kroky, function (key_skip, value_skip) {
            var vybery_skip = value_skip.split('_');
            if (vybery_skip[0] === vybery[0])
            {
              if ($('#kategorie_' + vybery[0]).length)
              {
                $('input[name="' + vybery_skip[0] + '_' + vybery_skip[1] + '"]').prop("disabled", true);
                $('input[name="' + vybery_skip[0] + '_' + vybery_skip[1] + '"]').prop('checked', false);
                $('#vybrano_nadpis_' + vybery_skip[0] + '_' + vybery_skip[1]).empty();
                $('#vybrano_nadpis_' + vybery_skip[0] + '_' + vybery_skip[1]).parent('h4').find('.dostupnost').remove();
                $('input[name="' + vybery_skip[0] + '_' + vybery_skip[1] + '"]').parent('label').parent().find('.ceny_plus').empty();
                $('input[name="' + vybery_skip[0] + '_' + vybery_skip[1] + '"]').parent('label').parent().find('.cena_od').remove();
                $('input[name="' + vybery_skip[0] + '_' + vybery_skip[1] + '"]').parent('label').parent().find('.dostupnost').remove();
                $('input[name="' + vybery_skip[0] + '_' + vybery_skip[1] + '"]').parent('label').parent('div').addClass("color_div_nohover");
                $('input[name="' + vybery_skip[0] + '_' + vybery_skip[1] + '"]').parent('label').parent('div').removeClass("color_div_vyb");

                $('#bar_vybery_nevybrano_' + vybery_skip[0] + '_' + vybery_skip[1]).show();
                $('#bar_vybery_vybrano_' + vybery_skip[0] + '_' + vybery_skip[1]).hide();
              } else
              {
                if ($('#vyber_select_' + vybery_skip[0] + '_' + vybery_skip[1]).is(":visible"))
                {
                  visible_vyber = visible_vyber + 1;
                }
                if (visible_vyber === 1)
                {
                  $('input[name="' + vybery_skip[0] + '_' + vybery_skip[1] + '"]').prop('checked', false);
                  $('input[name="' + vybery_skip[0] + '_' + vybery_skip[1] + '"]').parent('label').parent('div').removeClass("color_div_vyb");
                  $('#bar_vybery_nevybrano_' + vybery_skip[0] + '_' + vybery_skip[1]).show();
                  $('#bar_vybery_vybrano_' + vybery_skip[0] + '_' + vybery_skip[1]).hide();
                  $('#vybrano_nadpis_' + vybery_skip[0] + '_' + vybery_skip[1]).empty();
                } else if (vybery_skip[2] === 'produkt')
                {
                  $('input[name="' + vybery_skip[0] + '_' + vybery_skip[1] + '"]').prop("disabled", true);
                  $('input[name="' + vybery_skip[0] + '_' + vybery_skip[1] + '"]').prop('checked', false);
                  $('#vybrano_nadpis_' + vybery_skip[0] + '_' + vybery_skip[1]).empty();
                  $('#vybrano_nadpis_' + vybery_skip[0] + '_' + vybery_skip[1]).parent('h4').find('.dostupnost').remove();
                  $('input[name="' + vybery_skip[0] + '_' + vybery_skip[1] + '"]').parent('label').parent().find('.ceny_plus').empty();
                  $('input[name="' + vybery_skip[0] + '_' + vybery_skip[1] + '"]').parent('label').parent().find('.cena_od').remove();
                  $('input[name="' + vybery_skip[0] + '_' + vybery_skip[1] + '"]').parent('label').parent().find('.dostupnost').remove();
                  $('input[name="' + vybery_skip[0] + '_' + vybery_skip[1] + '"]').parent('label').parent('div').addClass("color_div_nohover");
                  $('input[name="' + vybery_skip[0] + '_' + vybery_skip[1] + '"]').parent('label').parent('div').removeClass("color_div_vyb");

                  $('#bar_vybery_nevybrano_' + vybery_skip[0] + '_' + vybery_skip[1]).show();
                  $('#bar_vybery_vybrano_' + vybery_skip[0] + '_' + vybery_skip[1]).hide();
                }else if (vybery_skip[2] === 'prislusenstvi')
                {
                  $('.sluzby_desky_blok').css({"display": "none"});
                  $('input[name="' + vybery_skip[0] + '_' + vybery_skip[1] + '"]').prop("disabled", false);
                  $('input[name="' + vybery_skip[0] + '_' + vybery_skip[1] + '"]').prop('checked', false);
                  $('input[name="' + vybery_skip[0] + '_' + vybery_skip[1] + '"]').parent('label').parent('div').removeClass("color_div_nohover");
                  $('input[name="' + vybery_skip[0] + '_' + vybery_skip[1] + '"]').parent('label').parent('div').removeClass("color_div_vyb");
                  $('input[name="' + vybery_skip[0] + '_' + vybery_skip[1] + '"]').parent('label').parent('div').css("display", "block");
                }
              }
              var cena_dr_n = 0;
              var cena_dr_s = 0;
              if ($('#cena_krok_' + vybery_skip[0] + '_' + vybery_skip[1]).val() > 0 && typeof $('#cena_krok_' + vybery_skip[0] + '_' + vybery_skip[1]).val() !== "undefined")
              {
                cena_dr_s = $('#cena_krok_' + vybery_skip[0] + '_' + vybery_skip[1]).val();
                $('#cena_krok_' + vybery_skip[0] + '_' + vybery_skip[1]).val(cena_dr_n);

              } else if ($('#cena_krok_' + vybery_skip[0]).val() > 0 && typeof $('#cena_krok_' + vybery_skip[0]).val() !== "undefined")
              {
                cena_dr_s = $('#cena_krok_' + vybery_skip[0]).val();
                $('#cena_krok_' + vybery_skip[0]).val(cena_dr_n);

              }
              zmen_cenu(cena_dr_s, cena_dr_n);
              $('#kod_' + vybery_skip[0] + '_' + vybery_skip[1]).val('');
              $('#kod_' + vybery_skip[0]).val('');
              //pouze liftor
              $("#rozmer_kom").val('');
              $("#rozmer_kom_vl").val('');
              $("#zmena_velikosti").slideUp("slow", function () {

              });
//              $("#zmena_velikosti").removeAttr('style');
              $("#canvas_zobrazeni").hide();

              $('#chyba_' + vybery_skip[0] + '_' + vybery_skip[1]).hide();
              $('#chyba_' + vybery_skip[0]).hide();
              krok = krok + 1;
            }
          });
          $("html,body").animate({ scrollTop: 0 });

          cgangeimg(slider_bx);

          $("#skiped_" + vybery[0]).val('true');
          $('#kategorie_' + vybery[0]).find('.color_div_vyb').removeClass('color_div_vyb');
          $(this).parent('label').parent('div').addClass('color_div_vyb');
          $('#kat_desky_' + vybery[0]).val('');
          dodani_vypis();
          preskocit_na_souhrn();
          sdileni_ulozeny();
        });
      }
    });
  }
  if (/*$('body').width() <= 1000*/window.matchMedia('(max-width: 1000px)').matches)
  {
    $('.bar_vybery_sec').click(function () {
      change_sekce($(this).attr("data-id"));
      if($("#vyber_select_" + $(this).attr("data-key")).length)
      {
        $([document.documentElement, document.body]).animate({
          scrollTop: $("#vyber_select_" + $(this).attr("data-key")).offset().top - $("#scrolable_konf").height()
        }, 100);
      }
      $(this).children('.bar_vybery_celek').children('.bar_vybery').hide();
    });
  } else
  {
    $('.bar_vybery_sec').click(function () {
      change_sekce($(this).attr("data-id"));
      if($("#vyber_select_" + $(this).attr("data-key")).length)
      {
        $([document.documentElement, document.body]).animate({
          scrollTop: $("#vyber_select_" + $(this).attr("data-key")).offset().top - $(".spodni_lista").height()
        }, 100);
      }
      $(this).children('.bar_vybery_celek').children('.bar_vybery').hide();
    });
  }
  $('.bar').click(function () {
    if (/*$('body').width() > 1000*/ window.matchMedia('(min-width: 1001px)').matches)
    {
      change_sekce($(this).attr("data-id"));
    } else
    {
      if ($(this).children('.bar_vybery_celek').length > 0)
      {
        if ($(this).children('.bar_vybery_celek').children('.bar_vybery').is(":visible"))
        {
          $(this).children('.bar_vybery_celek').children('.bar_vybery').hide();
        } else
        {
          $('.bar_vybery').hide();
          $(this).children('.bar_vybery_celek').children('.bar_vybery').show();
        }
      } else
      {
        change_sekce($(this).attr("data-id"));
      }
    }
  });

//  $('.smazat_krok').click(function () {
// 
//    var krok_smazat = $(this).attr("data-krok");
////     console.log(krok_smazat);
//     $.each(kroky, function (key, value) {
//        var vybery = value.split('_');
//      if (vybery[0] === krok_smazat)
//        {
//     
//          $('#pridat_' + $('input[name="' + vybery[0] + '_' + vybery[1] + '"]').val()).show();
//          $('#odebrat_' + $('input[name="' + vybery[0] + '_' + vybery[1] + '"]').val()).hide();
//          $('#pridat_dialog_' + $('input[name="' + vybery[0] + '_' + vybery[1] + '"]').val()).show();
//          $('#odebrat_dialog_' + $('input[name="' + vybery[0] + '_' + vybery[1] + '"]').val()).hide();
//        $('#' + vybery[0] + '_' + vybery[1] + '_none').click();
//        }
//      });
//       
//      $(this).parent('label').parent('div').addClass('color_div_vyb');
//      $(".chyba").hide();  
//  });

  $('#reference_konf').bxSlider({
    mode: 'fade',
    infiniteLoop: true,
    captions: true,
    speed: 1000,
    auto: true,
    controls: false,
    touchEnabled: false,
    pause: 5000

  });
  var slider_bx = false;
  if(/*$('body').width() >= 1000*/ window.matchMedia('(min-width: 1001px)').matches)
  {
    slider_bx = $('#eshop_obrazek_slider').bxSlider({
      mode: 'fade',
      speed: 0,
      infiniteLoop: true,
      controls: true,
      touchEnabled: false,
      responsive: true
    });
  }
  
  
  var slider_bx_li = $('#eshop_obrazek_slider-li').bxSlider({
    mode: 'fade',
    speed: 0,
    infiniteLoop: true,
    controls: true,
    touchEnabled: false
  });
  
  
  $(window).bind("load resize", function (e) {
    if(!slider_bx && /*$('body').width() >= 1000*/ window.matchMedia('(min-width: 1001px)').matches)
    {
      slider_bx = $('#eshop_obrazek_slider').bxSlider({
        mode: 'fade',
        speed: 0,
        infiniteLoop: true,
        controls: true,
        touchEnabled: false
      });
    }
    else if(slider_bx && /*$('body').width() <= 1000*/window.matchMedia('(max-width: 1000px)').matches)
    {
      slider_bx.destroySlider();
      checkOffset();
      bar_seda();
    }
    else
    {
      $("#konfigurator_udaje").removeAttr('style');
      cgangeimg(slider_bx);
      bar_seda();
    }
    
    $.each($(".selecty_parametry_celek"), function (key_param, value_param) {
      if($(value_param).css('display') !== 'none')
      {  
        setMezeraProSluzbyDesek();
      }
    });
    
  });

  skritcelyvyber();
  if ($('#preset_produkt').val() === '' || $('#preset_produkt').val().indexOf("k1_") < 0)
  {
    //vyberu první krok abych aktivoval správné vybery
    var vybery_prvni = kroky[0].split('_');
    var kat_preskoc = [];
    if (vybery_prvni[4])
    {
      kat_preskoc = vybery_prvni[4].split(':');
    }

    if (jQuery.inArray($('#js_kategorie_id').val(), kat_preskoc) >= 0)
    {
      $("#skladani_stolu_sekce_0").hide();
      $("#skladani_stolu_sekce_1").show();
      $.each(kroky, function (index_krok, value_krok) {

        var array_koroky = value_krok.split('_');
        if (array_koroky[0] == 0)
        {
          $('input[name="' + array_koroky[0] + '_' + array_koroky[1] + '"]').prop("disabled", false);
          $('input[name="' + array_koroky[0] + '_' + array_koroky[1] + '"]').prop('checked', true);
          $('input[name="' + array_koroky[0] + '_' + array_koroky[1] + '"]').parent('label').parent('div').addClass("color_div_vyb");
          $('input[name="' + array_koroky[0] + '_' + array_koroky[1] + '"]').parent('label').parent('div').removeClass("color_div_nohover");
          $('#kod_' + array_koroky[0] + '_' + array_koroky[1]).val($('input[name="' + array_koroky[0] + '_' + array_koroky[1] + '"]').val());
          $('#kod_' + array_koroky[0]).val($('#kod_' + array_koroky[0]).val() + '_' + $('input[name="' + array_koroky[0] + '_' + array_koroky[1] + '"]').val());
          zmen_cenu(0, 0);
        }
      });

      $('.button_pokracovat_0').click();
    }
  }
  if ($('#preset_produkt').val() !== '' && $('#preset_produkt').val().indexOf("k1_") >= 0)
  {
    var kontrola_sc = [];
    var sluzby_last = "";
    $.ajax({
      url: '/rsadmin/_funkce/eshop_dostupnost_produkty.php',
      type: "GET",
      dataType: "html",
      cache: false,
      async: false,
      data: {kod_produktu: $('#preset_produkt').val(), typ: 5, kategorie: $('#js_kategorie').val()},
      success: function (aData) {
        var def = JSON.parse(aData);
        if (def === null)
        {
          setCookie('save_konfigurator_auto', '',0);
          setCookie('save_konfigurator', '',0);
          window.location.replace("https://" + $('#konf_root').val() + $('#js_konf_odkaz').val());
        }       
        var last_krok = 0;
        var preskoc = [];
        $.each(def, function (index_krok, value_krok) {

          if (value_krok["kod_a"] == 'kategorie')
          {
            $('#' + index_krok).prop('checked', true);
            $('#' + index_krok).parent('label').parent('div').addClass("color_div_vyb");
            
      
            var id_kat = index_krok.split('_')[1];
            var id_kroku = index_krok.split('_')[0];
            
            preskoc[id_kroku] = false;
            
            $('#kat_desky_' + id_kroku).val(id_kat);
            if(id_kat === '9999')preskoc[id_kroku] = true;
            $.each($('#js_array').val().split(','), function (key_k, value_k) {

              var vybery_k = value_k.split('_');

              if (vybery_k[0] === id_kroku)
              {
                
                $('#vyber_select_' + vybery_k[0] + '_' + vybery_k[1]).removeClass('kat_hidden_konf');

                if ($('#vyber_select_' + vybery_k[0] + '_' + vybery_k[1]).find('#button_preskocit_' + vybery_k[0]).length)
                {
                  
                } else
                {
                  $('input[name="' + vybery_k[0] + '_' + vybery_k[1] + '"]').each(function (index, element) {

                    $(element).parent('label').parent('div').removeClass('kat_hidden_konf');
                    if (jQuery.inArray(id_kat, $(element).attr('data-kategorie').split(',')) !== -1)
                    {
                      
                    } else
                    {
                      $(element).parent('label').parent('div').addClass('kat_hidden_konf');
                    }
                    if ($('#vyber_select_' + vybery_k[0] + '_' + vybery_k[1]).find(".kat_hidden_konf").length == $('#vyber_select_' + vybery_k[0] + '_' + vybery_k[1]).find("input[type='radio']").length)
                    {
                      $('#vyber_select_' + vybery_k[0] + '_' + vybery_k[1]).addClass('kat_hidden_konf');
                    }
                    if (jQuery.inArray(id_kat, $(element).attr('data-kategorie').split(',')) !== -1 && $(element).attr("data-sluzby_desek") !== 'true')
                    {
                      $('#last_step_' + vybery_k[0]).val(vybery_k[0]+'_'+vybery_k[1]);
                      sluzby_last = vybery_k[0]+'_'+vybery_k[1];
                      
                    }
                  });
                }
                
              }
            });

          } else
          {
            $("input[type='radio']").each(function () {
              index_krok = index_krok.replaceAll("prefix_", "");
            
              if (value_krok["kod_a"] === $(this).attr('name') && value_krok["kod_a"] && index_krok === $(this).val())
              {
                if ($('input[name="' + $(this).attr('name') + '"]:checked').length == 0)
                {
                  $('#' + index_krok).prop("disabled", false);
                  $('#' + index_krok).prop('checked', true);
                  $('#' + index_krok).parent('label').parent('div').addClass("color_div_vyb");
                  $('#' + index_krok).parent('label').parent('div').removeClass("color_div_nohover");
                  $('#vybrano_nadpis_' + $(this).attr('name')).append($(this).parent('label').find('.vybrano_nazev').val());
                                 
                  if($('#' + index_krok).parent('label').find('#pridat_' + index_krok).length > 0)
                  {
                    $('#pridat_' + index_krok).hide();
                    $('#odebrat_' + index_krok).show();
                    $('#pridat_dialog_' + index_krok).hide();
                    $('#odebrat_dialog_' + index_krok).show();
                    if ($('#tel_aktive_' + value_krok["kod_a"]).val() === '1')
                    {
                      if (window.matchMedia('(max-width: 1000px)').matches)$('input[name="' +value_krok["kod_a"] + '"]').prop('disabled', false);
                      else $('input[name="' +value_krok["kod_a"] + '"]').prop('disabled', true);                    
                    }
                  }
                  $('#bar_vybery_nevybrano_' + $(this).attr('name')).hide();
                  $('#bar_vybery_vybrano_' + $(this).attr('name')).show();

                  $('#kod_' + value_krok["kod_a"]).val(index_krok);
                  

                  if($('#' + index_krok).attr("name") === sluzby_last)
                  {
                    
                      var sluzby = "#sluzby_"+sluzby_last;
                      var sluzby_podradi = parseFloat($('#' + index_krok).parent('label').parent('div').css('order'));

                      $('.sluzby_desky_blok').css({"display": "none"});

                       $.each($('#js_array').val().split(','), function (key_kod, value_kod) {
                         var vybery_kod = value_kod.split('_');
                         

                         if(vybery_kod[0] == value_krok["krok"] && vybery_kod[2] === 'prislusenstvi')
                         {
                           $('#vyber_select_' + vybery_kod[0] + '_' + vybery_kod[1] +'').appendTo(sluzby);
                           $(sluzby).css('order', sluzby_podradi); 
                           $('.sluzby_hidden').removeClass("sluzby_hidden");
                           $(sluzby).slideDown("slow", function () {
                              $(sluzby).css({"display": "table"});
                           });
                         }
                       });
                  }
                  if($('#' + index_krok).attr("data-vypisvyber") === 'true')
                  {
                    $('input[data-produktpuv="'+$('#' + index_krok).attr("data-produktpuv")+'"]').parent('label').parent('div').addClass('prislusko_hide');
                    $('#' + index_krok).parent('label').parent('div').removeClass("prislusko_hide");
                    $("#"+$(this).attr("data-produktpuv")+"_vybery input[data-value='"+index_krok+"']").prop('checked', true);  
                  }                      
                  if (value_krok["cena"])
                  {
                    $('#' + index_krok).parent().find('.nazev_radio_label').after("<span class='cena_od'>" + value_krok["cena"]+ "</span>");
                  }
                  if (value_krok["dodani_o"])
                  {
                    $('#' + index_krok).parent().find('.nazev_radio_label').after("<span class='dostupnost oranzova'><p>" + value_krok["dodani_o"].replaceAll("+", " ") + "</p></span>");
                    $('#' + index_krok).parent().find('.vybrano_dostupnost').val("<span class='dostupnost oranzova'><p>" + value_krok["dodani_o"].replaceAll("+", " ") + "</p></span>");
                  }
                  if (value_krok["dodani_a"])
                  {
                      $('#' + index_krok).parent().find('.nazev_radio_label').after("<span class='dostupnost'><p>" + value_krok["dodani_a"].replaceAll("+", " ") + "</p></span>");
                      $('#' + index_krok).parent().find('.vybrano_dostupnost').val("<span class='dostupnost'><p>" + value_krok["dodani_a"].replaceAll("+", " ") + "</p></span>");
                  }

                  if($('#' + index_krok).attr("data-sluzby_desek") !== 'true')$('#cena_krok_' + value_krok["krok"]).val(value_krok["cena_cislo"]);
                  
                  if($('#' + index_krok).attr("data-sluzby_desek") !== 'true')$('#kod_' + value_krok["krok"]).val($('#kod_' + value_krok["krok"]).val() + '_' + index_krok);

                  //pro komplet desky

                  if ($('#kod_' + value_krok["krok"]).val().indexOf("k2_k2_") >= 0)
                  {
                    $('#kod_' + value_krok["krok"]).val($('#kod_' + value_krok["krok"]).val().replace("k2_k2_", "k2_"));
                  }
                 
                  if(index_krok === 'atyp')
                  {
                    if (value_krok["parametry"])
                    {
                      var width = value_krok["parametry"][0].split('×')[0];
                      var height = value_krok["parametry"][0].split('×')[1];
                      if(height && width)
                      { 
                        $("#rozmer_kom").val(width + ' × ' + height + " cm");
                        $("#rozmer_kom_vl").val(width + '×' + height);
                        $("#canvas_zobrazeni").hide();
                        $(".rozmer_vlozeny_vlastni").remove();
                        $(".rozmer_vlozeny_vlastni_br").remove();
                        $('#canvasscale_width').val(width);
                        $('#canvasscale_height').val(height);
                        $('#width').val(width);
                        $('#height').val(height);
                        $('#atyp').parent().find('.nazev_radio_label').after("<label for='atyp' class='nazev_radio_label rozmer_vlozeny_vlastni'><p>: " + width + ' × ' + height + " cm</p></label>");
                      }
                    }
                    else
                    {
                      setCookie('save_konfigurator_auto', '',0);
                      setCookie('save_konfigurator', '',0);
                      window.location.replace("https://" + $('#konf_root').val() + $('#js_konf_odkaz').val());
                    }
                  }
                  else if(index_krok === 'home_assembly')
                  {
                    if (value_krok["parametry"])
                    {
                     $.ajax({
                        url: '/rsadmin/_funkce/eshop_konfigurator_kontrola_psc.php',
                        type: "GET",
                        dataType: "html",
                        cache: false,
                        data: {psc: value_krok["parametry"][0]},
                        success: function (aData) {
                          var result = JSON.parse(aData);
                          if (result.vysledek == 'true')
                          {
                            $("#pcs_sestaveni").val(value_krok["parametry"][0]);
                            $("#psc_sestavit_hod").val(value_krok["parametry"][0]);
//                              vyber_vybrany('home_assembly');
                          } else
                          {
                            setCookie('save_konfigurator_auto', '',0);
                            setCookie('save_konfigurator', '',0);
                            window.location.replace("https://" + $('#konf_root').val() + $('#js_konf_odkaz').val());
                          }
                        }
                      });
                    }
                    else
                    {
                      setCookie('save_konfigurator_auto', '',0);
                      setCookie('save_konfigurator', '',0);
                      window.location.replace("https://" + $('#konf_root').val() + $('#js_konf_odkaz').val());
                    }
                  }
                  else
                  {
                    if (value_krok["parametry"])
                    {
                      if($('#' + index_krok).parent('label').find(".select_sluzba").length)
                      {
                        $(this).parent('label').find(".selecty_parametry").css({"display": "block"});
                        setMezeraProSluzbyDesek();
                        $.each($('#' + index_krok).parent('label').find(".select_sluzba"), function (key_param, value_param) {
                          var selectet_option = $(this).find("option[value='"+value_krok["parametry"][key_param]+"']");
                          var parent_option = $('#'+selectet_option.attr('data-produktpuv'));
                          if(selectet_option.attr('data-produkt') === 'true')
                          {
                            if($(this).find("option[value='"+value_krok["parametry"][key_param]+"']").length > 0)
                            {  
                              $(this).val(value_krok["parametry"][key_param]).change();
                              parent_option.attr('data-cena', selectet_option.attr('data-cena'));
                              value_krok["cena_cislo"] = selectet_option.attr('data-cena');
                              var znamenko = '';
                              if(selectet_option.attr('data-cena') >= 0 )znamenko = '+ ';
                              parent_option.parent('label').find(".text_box_mal").html(znamenko+$("#mena_pred").val() + '' + numberWithSpaces(selectet_option.attr('data-cena')) + '' + $("#mena_za").val());
                            }
                            else
                            {
                              setCookie('save_konfigurator_auto', '',0);
                              setCookie('save_konfigurator', '',0);
                              window.location.replace("https://" + $('#konf_root').val() + $('#js_konf_odkaz').val());
                            }
                          }
                          else
                          {
                            if($(this).find("option[value='"+value_krok["parametry"][key_param]+"']").length > 0)
                            {  
                              $(this).val(value_krok["parametry"][key_param]).change();
                            }
                            else
                            {
                              setCookie('save_konfigurator_auto', '',0);
                              setCookie('save_konfigurator', '',0);
                              window.location.replace("https://" + $('#konf_root').val() + $('#js_konf_odkaz').val());
                            }
                          }
                        });
                      }   
                    }
                  }
                  
                  if (value_krok["cena_cislo"])
                  {
                    $('#cena_krok_' + value_krok["kod_a"]).val(value_krok["cena_cislo"]);
                    zmen_cenu(0, value_krok["cena_cislo"]);
                  }
                  
                  if ($('.ceny_' + value_krok["kod_a"]).val() == '1')
                  {
                    upravcenypodlevybraneho(value_krok["kod_a"].split('_')[0], value_krok["kod_a"].split('_')[1], index_krok);
                    //console.log('.ceny_' + value_krok["kod_a"]);
                  }
                
                }
              } else if (value_krok["kod_o"] == $(this).attr('name') && value_krok["kod_o"] && index_krok)
              {
                $('#' + index_krok).prop("disabled", false);
                $('#' + index_krok).parent('label').parent('div').removeClass("color_div_nohover");

                if (value_krok["cena"] && $('#' + index_krok).parent().find('.cena_od').length == 0)
                {
                  $('#' + index_krok).parent().find('.nazev_radio_label').after("<span class='cena_od'>" + value_krok["cena"]+ "</span>");
                }
                if (value_krok["dodani_o"] && $('#' + index_krok).parent().find('.dostupnost').length == 0)
                {
                  $('#' + index_krok).parent().find('.nazev_radio_label').after("<span class='dostupnost oranzova'><p>" + value_krok["dodani_o"].replaceAll("+", " ") + "</p></span>");
                  $('#' + index_krok).parent().find('.vybrano_dostupnost').val("<span class='dostupnost oranzova'><p>" + value_krok["dodani_o"].replaceAll("+", " ") + "</p></span>");
                }
                if (value_krok["dodani_a"] && $('#' + index_krok).parent().find('.dostupnost').length == 0)
                {
                  $('#' + index_krok).parent().find('.nazev_radio_label').after("<span class='dostupnost'><p>" + value_krok["dodani_a"].replaceAll("+", " ") + "</p></span>");
                  $('#' + index_krok).parent().find('.vybrano_dostupnost').val("<span class='dostupnost'><p>" + value_krok["dodani_a"].replaceAll("+", " ") + "</p></span>");
                }

//               if($('.ceny_'+value_krok["kod_o"]).val() == '1')
//                {
//                   upravcenypodlevybraneho(value_krok["kod_o"].split('_')[0],value_krok["kod_o"].split('_')[1],index_krok);
//                   console.log('.ceny_'+value_krok["kod_o"]);
//                }

              } else if (value_krok["kod_d"] == $(this).attr('name') && value_krok["kod_d"] && index_krok)
              {
                $('#' + index_krok).prop("disabled", true);
                $('#' + index_krok).prop('checked', false);
                $('#' + index_krok).parent('label').parent('div').hide();

                kontrola_sc.push($('#' + index_krok).val());
              }

              if (value_krok["krok"] !== krok_kon)
              {
                var krok_kon = value_krok["krok"];
//              aktivace_tlacika_pokracovat(krok_kon);
              }
              last_krok = value_krok["krok"];
            });
          }
        });
        
       
        $("input[type='radio']").each(function () {

          if ($('input[name="' + $(this).attr('name') + '"]:checked').length == 0)
          {
            if ($(this).attr('id') === $(this).attr('name'))
            {
              $('#' + $(this).attr('id')).prop("disabled", false);
              $('#' + $(this).attr('id')).prop('checked', true);
              $('#' + $(this).attr('id')).parent('label').parent('div').addClass("color_div_vyb");
              $('#' + $(this).attr('id')).parent('label').parent('div').removeClass("color_div_nohover");
              $('#kod_' + $(this).attr('id')).val($(this).val());
            }
          }
        });

        $("#skladani_stolu_sekce_0").hide();

        if($('#js_krok_konf').val() !== '')
        {
          if($("[data-url="+$('#js_krok_konf').val()+"]").length > 0)
          {
           last_krok = parseInt($("[data-url="+$('#js_krok_konf').val()+"]").attr("data-id")) - 1;
          } 
        }
        
        $.each(kroky, function (key, value) {
          var vybery = value.split('_');
          if ($('#preskoc_pokud_' + vybery[0]).length > 0)
          {
            var vybery_skip = $('#preskoc_pokud_' + vybery[0]).val().split(':');
            if (jQuery.inArray("" + $('#kod_0').val() + "", vybery_skip) !== -1)
            {
              $('#button_preskocit_' + vybery[0]).click();
            }
          }
          if(preskoc[vybery[0]] === true && last_krok > 0)
          {
            $('#button_preskocit_' + vybery[0]).click();
          }
        });
        
        skritcelyvyber(kontrola_sc);

        dodani_vypis();
        if(last_krok >= 0)$('.button_pokracovat_' + last_krok).click();
        else $("#skladani_stolu_sekce_0").show(); 
        sdileni_ulozeny();
        nastavPopis();
        $("#after_url").val('');
        cgangeimg(slider_bx);
        vypis_souhrnu_prubezne();
        preskocit_na_souhrn();
        setMezeraProSluzbyDesek();
      }
    });
  }



  $('#mnozstvi_konf').change(function ()
  {
    var input = $('#mnozstvi_konf');
    var hodnota = parseInt(input.val());
    if (isNaN(hodnota))
      hodnota = 1;

    input.val(hodnota);
    $('#mnozstvi').val(hodnota);

    var cena = parseFloat($("#cena_h").val()) * hodnota;
    $("#cena").replaceWith('<div id="cena" class="cena_konf_red">' + $("#mena_pred").val() + '' + numberWithSpaces(cena) + '' + $("#mena_za").val() + '</div>');
    $("#cena_1").replaceWith('<div id="cena_1">' + $("#js_celkem").val() + '<br><strong  class="cena_konf_red">' + $("#mena_pred").val() + '' + numberWithSpaces(cena) + '' + $("#mena_za").val() + '</strong></div>');
    $("#kosik_cena").replaceWith('<div id="kosik_cena">' + $("#mena_pred").val() + '' + numberWithSpaces(cena) + '' + $("#mena_za").val() + '</div>');
  });

  $('.okdaz_na_stul').click(function ()
  {
    if (/*$('body').width() > 1000*/ window.matchMedia('(min-width: 1001px)').matches)
    {
      slider_bx.goToSlide(0);
    }
  });


  $('.check_prislusko').click(function ()
  { 
     var kod_produktu = $(this).attr("data-id");
     if($('#'+kod_produktu).is(':checked'))
     {
       if($('#'+kod_produktu).attr("data-vypisvyber") === 'true')
       {
         $('#js_odebrat_podvyber').val('1');
       }  
     }
     $('#'+kod_produktu).click();
  });

  $('#zvetsit, #galerie_tel_zobrazit').click(function ()
  {
    if (/*$('body').width() > 1000*/ window.matchMedia('(min-width: 1001px)').matches) {
      var height = $(window).height() * 0.7;
      var width = $(window).width() * 0.7;
    } else {
      var height = $(window).height() * 0.9;
      var width = $(window).width() * 0.95;
    }
    
    if (/*$('body').width() > 1000*/ window.matchMedia('(min-width: 1001px)').matches)
    {
      var aktual_slide = slider_bx.getCurrentSlide();
    } else
      var aktual_slide = 0;

    $('body').css('overflow', 'hidden');
    $("#obr_galerie-li").dialog({
      resizable: true,
      height: height,
      width: width,
      modal: true,
      closeText: "",
      beforeClose: function () {
        $('body').css('overflow', '');
      },
      buttons: {
        "Zavřít": function () {
          $('body').css('overflow', '');
          $(this).dialog("close");
        }
      }
    });

    slider_bx_li.reloadSlider();
    slider_bx_li.goToSlide(aktual_slide);

  });

  $('.obr_galerie .open_galery').click(function ()
  {
    if (/*$('body').width() > 1000*/ window.matchMedia('(min-width: 1001px)').matches) {
      var height = $(window).height() * 0.7;
      var width = $(window).width() * 0.7;
    } else {
      var height = $(window).height() * 0.9;
      var width = $(window).width() * 0.95;
    }
    if ($(this).attr('data-slide'))
    {
      var aktual_slide = $(this).attr('data-slide');
      $('body').css('overflow', 'hidden');
      $("#obr_galerie-li").dialog({
        resizable: true,
        height: height,
        width: width,
        modal: true,
        closeText: "",
        beforeClose: function () {
          $('body').css('overflow', '');
        },
        buttons: {
          "Zavřít": function () {
            $('body').css('overflow', '');
            $(this).dialog("close");
          }
        }
      });
      slider_bx_li.reloadSlider();
      slider_bx_li.goToSlide(aktual_slide);
    }
  });

  $('.obr_galerie .fotka').click(function ()
  {
    if ($(this).attr('data-slide'))
    {
      var aktual_slide = $(this).attr('data-slide');
      slider_bx.goToSlide(aktual_slide);
    }
  });

  $('.obr_galerie-li .fotka').click(function ()
  {
    if ($(this).attr('data-slide'))
    {
      var aktual_slide = $(this).attr('data-slide');
      slider_bx_li.goToSlide(aktual_slide);
    }
  });
  
  if (/*$('body').width() > 1000*/ window.matchMedia('(min-width: 1001px)').matches)
  {
    slider_bx.reloadSlider();
    $("#zmena_velikosti input[type='number']").click(function ()
    {
      $(this).addClass('zmena_velikosti_input');
      $(this).parent('div').children('.zmena_velikosti_range').slideDown("slow", function () {});
      $(this).parent('div').children('.zmena_velikosti_range').show();
    });
  }

  if ($('#preset_produkt').val() === '' || $('#preset_produkt').val().indexOf("k1_") < 0)
  {

    var jednou = 0;
    $(document).ajaxStop(function () {
      if (jednou === 0)
      {
        jednou = 2;
        if ($("#3st").length)
          $("#3st").click();
        else if ($("#6st").length)
          $("#6st").click();
        else if ($("#7st").length)
          $("#7st").click();
        else if ($("#32st").length)
          $("#32st").click();

        $(document).ajaxStop(function () {
          if (jednou === 2)
          {

            if ($("#ncerna").length > 0)
              $("#ncerna").click();
            else if ($("#nmodra").length > 0)
              $("#nmodra").click();
//        console.log('ncerna');
            dodani_vypis();
            jednou = 3;
          }
        });
      }
    });
  }

  $('.tel_vypis_bar_p').click(function ()
  {
    $('#progress_produkt').show();
    $('.closed_tel').show();
    $('html, body').animate({scrollTop: '0px'}, 0);
  });

  $('.konf_zpet_js').click(function ()
  {
    change_sekce(parseFloat($("#sekce").val() - 1));
  });
  $('.closed_tel').click(function ()
  {
    if (/*$('body').width() <= 1000*/window.matchMedia('(max-width: 1000px)').matches)
    {
      $('#progress_produkt').hide();
      $('.bar_vybery').hide();
      $('.closed_tel').hide();
    }
  });


  if (/*$('body').width() <= 1000*/window.matchMedia('(max-width: 1000px)').matches)
  {
    $.each(kroky, function (key, value) {
      var vybery = value.split('_');
      if ($('#tel_aktive_' + vybery[0] + '_' + vybery[1]).val() == '1')
      {
        $('input[name="' + vybery[0] + '_' + vybery[1] + '"]').prop('disabled', false);
      }
    });
    $('.prava_dodani_img img').attr('src', '/images/svg/010-box-w.svg');
  }

  $('.velikost_input').click(function ()
  {
    var width = parseFloat($('#canvasscale_width').val());
    var width_min = parseFloat($('#canvasscale_width').attr('min'));
    var width_max = parseFloat($('#canvasscale_width').attr('max'));
    var height = parseFloat($('#canvasscale_height').val());
    var height_min = parseFloat($('#canvasscale_height').attr('min'));
    var height_max = parseFloat($('#canvasscale_height').attr('max'));
    if (width >= width_min && height >= height_min && width <= width_max && height <= height_max)
    {
      $("#rozmer_kom").val(width + ' × ' + height + " cm");
      $("#rozmer_kom_vl").val(width + '×' + height);
      $("#zmena_velikosti").slideUp("slow", function () {

      });
//      $("#zmena_velikosti").removeAttr('style');
      $("#canvas_zobrazeni").hide();
      $(".rozmer_vlozeny_vlastni").remove();
      $(".rozmer_vlozeny_vlastni_br").remove();
      $('#atyp').parent().find('.nazev_radio_label').after("<label for='atyp' class='nazev_radio_label rozmer_vlozeny_vlastni'><p>: " + width + ' × ' + height + " cm</p></label>");
//      $("#zmena_velikosti").hide();
      $("#open_atyp").val('1');
      $('#atyp').click();
    }
  });

  $('.sestaveni_input').click(function ()
  {
    $('#psc_sestavit_hod').val('');
    if ($('#pcs_sestaveni').val() != '')
    {
      $.ajax({
        url: '/rsadmin/_funkce/eshop_konfigurator_kontrola_psc.php',
        type: "GET",
        dataType: "html",
        cache: false,
        data: {psc: $('#pcs_sestaveni').val()},
        success: function (aData) {
          var result = JSON.parse(aData);
//          console.log(result);
          if (result.vysledek == 'true')
          {
            $("#psc_sestavit_hod").val($('#pcs_sestaveni').val());
            $("#open_sestaveni").val('1');
            vyber_vybrany('home_assembly');
          } else
          {
            $('#chyba_sestaveni').show();
            vyber_odebrat('home_assembly');
          }
        }
      });
    } else
    {
      $('#chyba_sestaveni').show();
      vyber_odebrat('home_assembly');
    }
  });



  var slider_bx_span = null;
  $(document).on('click', '.rada_span', function () {
    
    if (/*$('body').width() > 1000*/ window.matchMedia('(min-width: 1001px)').matches) {
      var height = $(window).height() * 0.7;
      var width = $(window).width() * 0.6;
    } else {
      var height = $(window).height() * 0.9;
      var width = $(window).width() * 0.95;
    }

    var kod_dialogu = $(this).attr("data-id");
    $('body').css('overflow', 'hidden');
    $("#dialog_" + kod_dialogu).dialog({
      resizable: true,
      height: height,
      width: width,
      modal: true,
      closeText: "",
      beforeClose: function () {
        $('body').css('overflow', '');
      },
      buttons: {
        Zavřít: function () {
          $('body').css('overflow', '');
          if (slider_bx_span)
            slider_bx_span.destroySlider();
          $(this).dialog("Zavřít");
        }
      }
    });

    slider_bx_span = $('#eshop_obrazek_slider_span_' + kod_dialogu).bxSlider({
      mode: 'fade',
      speed: 0,
      infiniteLoop: true,
      controls: true,
      touchEnabled: false
    });
    slider_bx_span.reloadSlider();
  });
  $(document).on('click', '.foto_galerie_span .fotka', function ()
  {
    if ($(this).attr('data-slide'))
    {
      var aktual_slide = $(this).attr('data-slide');
      if (slider_bx_span)slider_bx_span.goToSlide(aktual_slide);
    }
  });

$(window).bind("load resize scroll", function (e) {
  if(elementInViewport('.vyber_select_ob'))
  {
    nastavPopis();
  }
});

  poradiVybery();
  
  $('.do_kosiku').click(function(){
    if(preskocit_na_souhrn_kontrola())
    {
        var next_krok = parseInt($('#sekce').val()) + 1;
        var last_krok = 0;
        $.each($('#js_array').val().split(','), function (key_k, value_k) {
          var vybery_sec = value_k.split('_');
          last_krok = vybery_sec[0];
        });
        if ($('#preskoc_pokud_' + next_krok).length > 0)
        {
          var vybery_skip = $('#preskoc_pokud_' + next_krok).val().split(':');
          if (jQuery.inArray("" + $('#kod_' + $('#sekce').val()).val(), vybery_skip) !== -1)
          {
            $('#button_preskocit_' + next_krok).click();
          }
        }

        if(preskocit_na_souhrn_kontrola(false) === false)
        {
          if($('#button_preskocit_' + next_krok).length > 0)$('#button_preskocit_' + next_krok).click();
          else if($('#button_preskocit_' + $('#sekce').val()).length > 0)$('#button_preskocit_' + $('#sekce').val()).click();
        }
        $("#skladani_stolu_sekce_"+ $('#sekce').val()).hide();
        $('.button_pokracovat_' + last_krok).click();
    }
  }); 
  
  $('.vybery_produkt_vyber img[title]').tooltip(
  {
    tooltipClass: "tooltip",
    content: function () { return $(this).prop('title'); }
  });
  
 
  $('.sdilet_ulozit_konf').click(function ()
  {
    $('body').css('overflow', 'hidden');
    $("html,body").animate({ scrollTop: 0 });
    $("#sdilet_ulozit_konf_dialog").dialog({
      resizable: true,
      dialogClass: 'dialog_sdilet_ulozit',
      width: '80%',
      modal: true,
      closeText: "",
      beforeClose: function () {
        $('body').css('overflow', '');
        $('*[data-typ="ulozeno"]').css( "display", "none" );
        $('*[data-typ="kopirovano"]').css( "display", "none" );
        $('#sdilet_ulozit_konf_dialog').find('.chyba_sec').css( "display", "none" );
      },
      buttons: {
        "Zavřít": function () {
          $('body').css('overflow', '');
          $(this).dialog("close");
        }
      }
    });
  });
  
  $('.ulozit_konf').click(function ()
  {
    sdileni_ulozeny_funkce('ulozit');
  });
  $('.nacist_konf').click(function ()
  {
    sdileni_ulozeny_funkce('nacist');
  });
  $('.generovat_odkaz').click(function ()
  {
    sdileni_ulozeny_funkce('kopirovat');
  });
  $('.zavrit_dialog').click(function ()
  {
    setCookie('save_konfigurator_auto', '',0);
    setCookie('save_konfigurator', '',0);
    $("div:ui-dialog:visible").dialog("close");
  });
  $('#zrusit_okno_konf').change(function ()
  {
    setCookie('save_konfigurator_skryt', 'true', 180);
    $("div:ui-dialog:visible").dialog("close");
  });
  
  $('.select_sluzba').change(function ()
  {
    var selectet_option = $(this).find(":selected");
    if(selectet_option.attr('data-produkt') === 'true')
    {
      var parent_option = $('#'+selectet_option.attr('data-produktpuv'));
      if(parent_option.parent('label').parent('div').hasClass("color_div_vyb"))
      {
        zmen_cenu(parent_option.attr('data-cena'), selectet_option.attr('data-cena'));
        parent_option.attr('data-cena', selectet_option.attr('data-cena'));
        var znamenko = '';
        if(selectet_option.attr('data-cena') >= 0 )znamenko = '+ ';
        parent_option.parent('label').find(".text_box_mal").html(znamenko+$("#mena_pred").val() + '' + numberWithSpaces(selectet_option.attr('data-cena')) + '' + $("#mena_za").val());
        $('#cena_krok_'+parent_option.attr('name')).val(selectet_option.attr('data-cena'));
      }
      else
      {
        parent_option.attr('data-cena', selectet_option.attr('data-cena'));
        var znamenko = '';
        if(selectet_option.attr('data-cena') >= 0 )znamenko = '+ ';
        parent_option.parent('label').find(".text_box_mal").html(znamenko+$("#mena_pred").val() + '' + numberWithSpaces(selectet_option.attr('data-cena')) + '' + $("#mena_za").val());
      }
      dodani_vypis();
    }
  });
 
  sdileni_ulozeny_funkce('muze_nacist');
  PrisluskoNavaznost();
 });
 
function PrisluskoNavaznost() {
  
  $('.navaznost').hide();
  $('.navaznost_rada').hide();
  
  if($('#js_prislusko_nazavnost').val() !== '')
  {
    var produkty = $('#js_prislusko_nazavnost').val().split(',');
    $.each(produkty, function (key_produkt, value_produkt) {
      var produkt = value_produkt.split(';');
      
      $('#'+produkt[0]).parent('label').find('.img_vyberu').attr('src', $('#'+produkt[0]).parent('label').find('.img_vyberu').attr('data-puv'));
      
      if($('#kod_'+produkt[1]).val().split('_').length !== 4)return;

      if($('#'+produkt[0]).length >= 1 && $('#kod_'+produkt[1]).length >= 1)
      {
        $.each($("input[data-produktpuv='"+produkt[0]+"']"), function (key_vybery, value_vybery) {
          if($(value_vybery).attr('data-ignore') === 'true')
          {
            var kod_kroku = $('#kod_'+produkt[1]).val().split('_');
            if($(value_vybery).val().indexOf(kod_kroku[produkt[2]]) != -1)
            {
              $(value_vybery).parent('label').find('.navaznost').show();
              $(value_vybery).parent('label').parent('label').parent('div').find('.navaznost_rada').css({"display": "table"});;
            }
          }
          else
          {
            if($(value_vybery).attr('data-vypisvyber') === 'true')
            {
              var kod_kroku = $('#kod_'+produkt[1]).val().split('_');
              if($(value_vybery).val().indexOf(kod_kroku[produkt[2]]) != -1)
              {
                var url_img = $(value_vybery).parent('label').find('.img_vyberu').attr('src');
                $('#'+$(value_vybery).attr('data-produktpuv')).parent('label').find('.img_vyberu').attr('src',url_img);
              }
            }
          }      
        });        
      }
    });
  }
}
function nastavPopis() {

  if ($('.popis_produktu_konf').length <= 0)return;
  var kod_kontrola = '';
   var krok = -1;
    $.each($('#js_array').val().split(','), function (key_k, value_k) {
    var vybery = value_k.split('_');
    if (vybery[2] === 'produkt')
    {
      if ($("#kod_" + vybery[0]).val().length > 2 && krok !== vybery[0])
      {
        krok = vybery[0];
        if (kod_kontrola !== '')
          kod_kontrola = kod_kontrola + '|';
        kod_kontrola = kod_kontrola + $('#kod_' + vybery[0]).val();
      }
    } else if (vybery[2] === 'prislusenstvi' && $('#kod_' + vybery[0] + '_' + vybery[1]).val())
    {
      if (kod_kontrola !== '')
        kod_kontrola = kod_kontrola + '|';
      kod_kontrola = kod_kontrola + $('#kod_' + vybery[0] + '_' + vybery[1]).val();
    }
  });
  
  if(!kod_kontrola)return;
  
  if ($('#js_popis_pod').val() != kod_kontrola)
  {
    $('.popis_produktu_konf').empty();
    $.ajax({
      url: '/rsadmin/_funkce/eshop_dostupnost_produkty.php',
      type: "GET",
      dataType: "html",
      cache: false,
      async: true,
      data: {kod_produktu: kod_kontrola, typ: 10, rozpad: 0},
      success: function (aData) {
        if (aData)
        {
          var result = JSON.parse(aData);
          $('.popis_produktu_konf').append(result.product_page); 
          if( $('.popis_produktu_konf .slider div').length > 0 )
          {
            $('.popis_produktu_konf .slider div').bxSlider({
              mode: 'horizontal',
              speed: 1000,
              infiniteLoop: true,
              controls: true,
              touchEnabled: true,
              adaptiveHeight: false,
              preloadImages: 'all',
              captions: true
            });
          }
        }
      }
    });
    $('#js_popis_pod').val(kod_kontrola);
  }
}

function elementInViewport(element_class) {

  var myElement = null;
  myElement = $(element_class + ':visible').last()[0];
 
  if(typeof myElement !== 'undefined')
  {
    var bounding = myElement.getBoundingClientRect();

    if (bounding.top >= 0 && bounding.left >= 0 && bounding.right <= (window.innerWidth || document.documentElement.clientWidth) && bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight)) {

      return true;
    } else {

      return false;
    }
  }
}

// Update the count down every 1 second
//var x = setInterval(function () {
//  if ($('#js_rezervace_odpocet').length() > 0)
//  {
//    if ($('#js_rezervace_odpocet').val())
//    {
//      var countDownDate = new Date($('#js_rezervace_odpocet').val()).getTime();
//
//  //      console.log("1/1/1900 " + $('#js_rezervace_odpocet').val());
//      var now = new Date().getTime();
//      var rezervace_id = '';
//      // Find the distance between now and the count down date
//      var distance = countDownDate - now;
//
//  //      console.log(distance);
//      // Time calculations for days, hours, minutes and seconds
//      var days = Math.floor(distance / (1000 * 60 * 60 * 24));
//      var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
//      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
//      var seconds = Math.floor((distance % (1000 * 60)) / 1000);
//
//      $('.js_odpocet_' + $("#js_rezervace_krok").val()).empty();
//      $('.js_odpocet_' + $("#js_rezervace_krok").val()).append($("#js_rezervace_text").val() + ' ' + minutes + "m " + seconds + "s ");
//
//      // If the count down is finished, write some text
//      if (distance < 0) {
//  //        clearInterval(x);
//        $('.js_odpocet_' + $("#js_rezervace_krok").val()).empty();
//        $('.js_odpocet_' + $("#js_rezervace_krok").val()).append($("#js_rezervace_text_konec").val());
//
//        if ($('#js_rezervace_id').val() != '')
//        {
//          rezervace_id = $('#js_rezervace_id').val();
//
//          $('#js_rezervace_id').val('');
//          $('#js_rezervace_odpocet').val('');
//          $('#js_rezervace_krok').val('');
//          $.ajax({
//            url: '/rsadmin/_funkce/eshop_dostupnost_produkty.php',
//            type: "GET",
//            dataType: "html",
//            async: false,
//            cache: false,
//            data: {typ: 9, id_rez: rezervace_id},
//            success: function (aData) {
//
//            }
//          });
//        }
//      }
//    } else
//    {
//      $('.js_odpocetvse').empty();
//    }
//  }
//}, 1000);

function change_sekce(id_sekce, select = null)
{
  var sekce = 0;
  if (id_sekce == 0)
  {
    var vybery_prvni = $('#js_array').val().split(',')[0].split('_');
    var kat_preskoc = [];
    if (vybery_prvni[4])
    {
      kat_preskoc = vybery_prvni[4].split(':');
    }

    if (jQuery.inArray($('#js_kategorie_id').val(), kat_preskoc) >= 0)
    {
      var odkaz = $("#js_konf_odkaz").val().replace(/(<([^>]+)>)/ig, "");
      window.location.href = odkaz;
      return;
    }
  }

  if ($("#skiped_" + id_sekce).val() === 'true')
  {
    
    var id_sekce_upr = id_sekce;
    if ($("#sekce").val() > id_sekce)
      id_sekce_upr = id_sekce - 1;
    else
      id_sekce_upr = id_sekce++;
      
    var schovat = 1;  
    if ($('#preskoc_pokud_' + id_sekce).length > 0)
    {
      var vybery_skip = $('#preskoc_pokud_' + id_sekce).val().split(':');
      if (jQuery.inArray("" + $('#kod_' + id_sekce_upr).val() + "", vybery_skip) !== -1)
      {
        schovat = 0;
      }
    }
//    var schovat = 0;
//    $("input[type='radio']").each(function () {
//      var data_kon = $(this).attr('name').split('_');     
//      if (data_kon[0] === id_sekce && data_kon[1] !== '999999')
//      {
//        if ($(this).is(":not(:disabled)"))
//        {
////          console.log($(this).val());
//          schovat = 1;
//        }
//      }
//
//    });
    if ($('#skladani_stolu_sekce_' + id_sekce).find("input[type='radio']").length === 0 || schovat === 0)
    {
      id_sekce = id_sekce_upr;
    }
  }


  if (id_sekce !== 0)
  {
    sekce = id_sekce - 1;
  } else
  {
    sekce = id_sekce;
  }
  if (id_sekce <= 0)
    id_sekce = 0;

  var sekce_now = parseFloat($("#sekce").val()) + 1;
  if (sekce_now == id_sekce || id_sekce < sekce_now)
  {
    var posledni = 0;
    $.each($('#js_array').val().split(','), function (key, value) {
      var vybery = value.split('_');
      $("#skladani_stolu_sekce_" + vybery[0]).hide();
      posledni = parseFloat(vybery[0]) + 1;
    });
    $("#skladani_stolu_sekce_" + posledni).hide();
  }
  if (sekce_now == id_sekce)
  {
    $("#skladani_stolu_sekce_" + sekce).show();
    $('.button_pokracovat_' + sekce).click();

  } else if (id_sekce < sekce_now)
  {
    $("#skladani_stolu_sekce_" + id_sekce).show();
    $("#sekce").val(id_sekce);
    $('.tel_vypis_bar_p').html($("#bar_" + id_sekce).attr("data-nazev"));
    bar_seda();
  }
  if (/*$('body').width() <= 1000*/window.matchMedia('(max-width: 1000px)').matches)
  {
    $('#progress_produkt').hide();
    $('.closed_tel').hide();
  }
  if (select)
  {
    setTimeout(
            function ()
            {
              if($("#vyber_select_2_" + select).length)
              {
                $([document.documentElement, document.body]).animate({
                  scrollTop: $("#vyber_select_2_" + select).offset().top - 200
                }, 200);
              }
            }, 500);
  }
  vypis_souhrnu_prubezne();
}

function cgangeimg(slider_bx) {
  $("#eshop_obrazek_img_loading").show();
  
  var krok = -1;
  var produkty_obr = '';
  $.each($('#js_array').val().split(','), function (key, value) {
    var vybery = value.split('_');
    if (vybery[2] === 'produkt')
    {
      if ($("#kod_" + vybery[0]).val().length > 2 && krok !== vybery[0])
      {
        krok = vybery[0];
        if (produkty_obr !== '')
          produkty_obr = produkty_obr + ':';
        produkty_obr = produkty_obr + $('#kod_' + vybery[0]).val();
      }
    } else if (vybery[2] === 'prislusenstvi' && $('#kod_' + vybery[0] + '_' + vybery[1]).val())
    {
      if (produkty_obr !== '')
        produkty_obr = produkty_obr + ':';
      produkty_obr = produkty_obr + $('#kod_' + vybery[0] + '_' + vybery[1]).val();
    }
  });
  
  var galerie = '';
  var slider = '';
  if (produkty_obr.indexOf('_2st') != -1)
  {
    galerie = 'foto_2st';
    slider = 'slider_2st';
  } else if (produkty_obr.indexOf('_3st') != -1)
  {
    galerie = 'foto_3st';
    slider = 'slider_3st';
  } else if (produkty_obr.indexOf('_4st') != -1)
  {
    galerie = 'foto_4st';
    slider = 'slider_4st';
  } else if (produkty_obr.indexOf('_5st') != -1)
  {
    galerie = 'foto_5st';
    slider = 'slider_5st';
  } else if (produkty_obr.indexOf('_6st') != -1)
  {
    galerie = 'foto_6st';
    slider = 'slider_6st';
  } else if (produkty_obr.indexOf('_7st') != -1)
  {
    galerie = 'foto_7st';
    slider = 'slider_7st';
  } else if (produkty_obr.indexOf('_8st') != -1)
  {
    galerie = 'foto_8st';
    slider = 'slider_8st';
  } else if (produkty_obr.indexOf('_9st') != -1)
  {
    galerie = 'foto_9st';
    slider = 'slider_9st';
  } else if (produkty_obr.indexOf('_10st') != -1)
  {
    galerie = 'foto_10st';
    slider = 'slider_10st';
  } else
  {
    galerie = 'foto_none';
    slider = 'slider_none';
  }
  
  if (slider)
  {
    $("#eshop_obrazek_slider").find('.slider_u_konfiguratoru_r').remove();
    $("#eshop_obrazek_slider").append($("#" + slider).html());
    $("#eshop_obrazek_slider-li").find('.slider_u_konfiguratoru_r').remove();
    $("#eshop_obrazek_slider-li").append($("#" + slider).html());
  }
  if (window.matchMedia('(min-width: 1001px)').matches)
  {
    slider_bx.reloadSlider();
    slider_bx.goToSlide(0);
  }
  if (galerie && $("#" + galerie).is(":hidden"))
  {

    $(".foto-galerie").hide();
    if (/*$('body').width() > 1000*/ window.matchMedia('(min-width: 1001px)').matches)
    {
      $("#" + galerie).show();
    }
    $("#" + galerie + "-li").show();
  }
   
  if (($("#kod_obr").val() !== produkty_obr || $("#kod_obr").val().indexOf('_atyp') != -1) && produkty_obr !== '')
  {
    $("#kod_obr").val(produkty_obr);
    $.ajax({
      url: '/rsadmin/_funkce/eshop_konfigurator_obr.php',
      type: "GET",
      dataType: "html",
      cache: false,
      data: {obr: produkty_obr, url: 'true', vl: $("#rozmer_kom_vl").val()},
      success: function (aData)
      {
        $("#eshop_obrazek_img").attr("src", aData);
        $("#eshop_obrazek_img-li").attr("src", aData);
        $(".lightbox_stul img").attr("src", aData);
        
        if ($('.sdilet_ulozit_img').length > 0)$(".sdilet_ulozit_img").attr("src", aData);

        $("#eshop_obrazek_img_loading").hide();
      }
    });
  } else
  {
    $("#eshop_obrazek_img_loading").hide();
  }
}
function aktivace_objednani_skryti(result, can_objednat)
{

  if (result.cena_od)
  {
    $.each(result.cena_od, function (key_d, value) {
      if (value !== '' && $('#' + key_d).length > 0)
      {

        $('#' + key_d).parent().find('.cena_od').remove();
        if (value.old_cena)
          $('#' + key_d).parent().find('.vyber_nazev_js').after("<span class='cena_od'><del>" + value.old_cena + "</del> " + value.cena + "</span>");
        else
          $('#' + key_d).parent().find('.vyber_nazev_js').after("<span class='cena_od'>" + value.cena + "</span>");
      }
    });
  }
  if (result.activate)
  {
    $.each(result.activate, function (key_d, value) {
      if (value !== '' && $('#' + value).length > 0)
      {
        $('#' + value).prop("disabled", false);
        $('#' + value).parent('label').parent('div').removeClass('color_div_nohover');
        $('#' + value).parent().find('.dostupnost').remove();

        if (can_objednat == 'true' && value in result.dodani)
        {
          if ($('#' + value).parent().find('.rozmer_vlozeny_vlastni').length) {
            $('#' + value).parent().find('.rozmer_vlozeny_vlastni').after("<span class='dostupnost'><p>" + result.dodani[value] + "</p></span>");
          } else
            $('#' + value).parent().find('.vyber_nazev_js').after("<span class='dostupnost'><p>" + result.dodani[value] + "</p></span>");

          $('#' + value).parent().find('.vybrano_dostupnost').val("<span class='dostupnost'><p>" + result.dodani[value] + "</p></span>");
        }
      }
    });
  }
  if (result.naobjednani)
  {
    $.each(result.naobjednani, function (key_d, value) {
      if (value !== '' && $('#' + value).length > 0)
      {
        $('#' + value).prop("disabled", false);
        $('#' + value).parent('label').parent('div').removeClass('color_div_nohover');
        $('#' + value).parent().find('.dostupnost').remove();

        if (can_objednat == 'true' && value in result.dodani)
        {
          if ($('#' + value).parent().find('.rozmer_vlozeny_vlastni').length) {
            $('#' + value).parent().find('.rozmer_vlozeny_vlastni').after("<span class='dostupnost oranzova'><p>" + result.dodani[value] + "</p></span>");
          } else
            $('#' + value).parent().find('.vyber_nazev_js').after("<span class='dostupnost oranzova'><p>" + result.dodani[value] + "</p></span>");

          $('#' + value).parent().find('.vybrano_dostupnost').val("<span class='dostupnost oranzova'><p>" + result.dodani[value] + "</p></span>");
        }
      }
    });
  }
  $.each($('#js_array').val().split(','), function (key_k, value_k) {

    var vybery_k = value_k.split('_');
    if (vybery_k[2] == 'prislusenstvi' && vybery_k[0] == 2)
    {
      $('#vyber_select_' + vybery_k[0] + '_' + vybery_k[1]).show();
      $('input[name="' + vybery_k[0] + '_' + vybery_k[1] + '"]').parent('label').parent('div').show();
      $('input[name="' + vybery_k[0] + '_' + vybery_k[1] + '"]').prop("disabled", false);
      $('input[name="' + vybery_k[0] + '_' + vybery_k[1] + '"]').parent('label').parent('div').removeClass("color_div_nohover");
    }
  });
  if (result.skryt)
  {
    $.each(result.skryt, function (key_d, value) {
      if (value !== '' && $('#' + value).length > 0)
      {
        var kroky_dea = $('#' + value).attr('name').split('_');

        $('#' + value).prop("checked", false);
        $('#' + value).parent('label').parent('div').hide();
        $('#' + value).parent('label').parent('div').removeClass("color_div_vyb");

        if ($('#kod_' + kroky_dea[0]).val().indexOf('_' + value) != -1)
        {
          $('#kod_' + kroky_dea[0] + '_' + kroky_dea[1]).val('');
          $('#kod_' + kroky_dea[0]).val($('#kod_' + kroky_dea[0]).val().replace('_' + value, ""));
          $('#vybrano_nadpis_' + kroky_dea[0] + '_' + kroky_dea[1]).empty();
          var deaktivace = 0;
          $.each($('#js_array').val().split(','), function (key_k, value_k) {
            var vybery_k = value_k.split('_');

            if (kroky_dea[0] === vybery_k[0])
            {
              if (deaktivace === 1)
              {

                $('#vybrano_nadpis_' + vybery_k[0] + '_' + vybery_k[1]).empty();
                $('input[name="' + vybery_k[0] + '_' + vybery_k[1] + '"]').prop("checked", false);
                $('input[name="' + vybery_k[0] + '_' + vybery_k[1] + '"]').prop("disabled", true);
                $('input[name="' + vybery_k[0] + '_' + vybery_k[1] + '"]').parent('label').parent('div').addClass("color_div_nohover");
                $('input[name="' + vybery_k[0] + '_' + vybery_k[1] + '"]').parent('label').parent('div').removeClass("color_div_vyb");
                $('#kod_' + vybery_k[0] + '_' + vybery_k[1]).val('');
                $('#kod_' + vybery_k[0]).val($('#kod_' + vybery_k[0]).val().replace('_' + $('input[name="' + vybery_k[0] + '_' + vybery_k[1] + '"]').val(), ""));
              } else if (kroky_dea[1] === vybery_k[1])
              {
                deaktivace = 1;
              }
            }
          });

        } else
        {
          if ($('#kod_' + $('#' + value).attr('name')).val().indexOf(value) != -1)
          {
            $('#vybrano_nadpis_' + $('#' + value).attr('name')).empty();
            $('#kod_' + $('#' + value).attr('name')).val(''); 
          }
          $('#' + value).prop("checked", false);
          $('#' + value).prop("disabled", true);
          $('#' + value).parent('label').parent('div').addClass("color_div_nohover");
          $('#' + value).parent('label').parent('div').removeClass("color_div_vyb");                
        }
      }
    });
    skritcelyvyber(result.skryt);
  }
  preskocit_na_souhrn();
  sdileni_ulozeny();
}
function skritcelyvyber(skryte)
{
  var kontrola_s = [];
  var k = 0;
  $.each($('#js_array').val().split(','), function (key_k, value_k) {
    var vybery_k = value_k.split('_');
    $('#vyber_select_' + vybery_k[0] + '_' + vybery_k[1]).show();
  });
  if (!skryte)
  {
  
    $.each($('#js_array').val().split(','), function (key_k, value_k) {
      var vybery_k = value_k.split('_');
      $('#vyber_select_' + vybery_k[0] + '_' + vybery_k[1]).show();
      if ($('#bar_vybery_' + vybery_k[0]).find("div").length == 0)
      {
        $('#bar_vybery_' + vybery_k[0]).hide();
      }
      if ($('#vyber_select_' + vybery_k[0] + '_' + vybery_k[1]).find('#button_preskocit_' + vybery_k[0]).length)
      {
      } else
      {
        kontrola_s[k] = vybery_k[0] + '_' + vybery_k[1];
        k++;
      }
    });

    $.each(kontrola_s, function (key_d, value) {
      if ($('#vyber_select_' + value).find("input[type='radio']").length == 0)
      {
        $('#vyber_select_' + value).hide();
      }
    });
  } else
  {
    $.each(skryte, function (key_d, value) {
      $.each($('#js_array').val().split(','), function (key_k, value_k) {
        var vybery_k = value_k.split('_');

        $('#vyber_select_' + vybery_k[0] + '_' + vybery_k[1]).show();

        if ($('#vyber_select_' + vybery_k[0] + '_' + vybery_k[1]).find('#button_preskocit_' + vybery_k[0]).length)
        {
        } else
        {
          if ($('input[name="' + vybery_k[0] + '_' + vybery_k[1] + '"]').val() === value)
          {
            kontrola_s[k] = vybery_k[0] + '_' + vybery_k[1];
            k++;
          }       
          if ($('#vyber_select_' + vybery_k[0] + '_' + vybery_k[1]).find("input[type='radio']").length === 0)
          {
            $('#vyber_select_' + vybery_k[0] + '_' + vybery_k[1]).hide();
          }
        }
      });
    });

    $.each(kontrola_s, function (key_d, value) {
      var kontrola_f = [];
      var kontrola_fc = [];
      $("input[name='"+value+"']").each(function (key_d_input, value_input) {
          kontrola_fc.push(1);
          if ($(value_input).parent('label').parent('div').css('display') === 'none')
          {
            kontrola_f.push(1);
          }
      });
      if (kontrola_fc.length === kontrola_f.length)
        $('#vyber_select_' + value).hide();
    });
  }
}

function numberWithSpaces(x) {
  var parts = parseFloat(x).toFixed($("#zaokrouhlit").val());
  parts = parseFloat(parts).toFixed($("#des_mist").val());
  parts = parts.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ").replace(".", ","); 
  return parts;
}

function zmen_cenu(x, y) {

  var cena = $("#cena_h").val();

  cena = parseFloat(cena) - parseFloat(x) + parseFloat(y);

  $('#cena_h').val(cena);
  cena = cena * parseFloat($('#mnozstvi').val());
//  if (cena > 0)
//  {

  $("#cena").show();
  $("#cena").replaceWith('<div id="cena" class="cena_konf_red">' + $("#mena_pred").val() + '' + numberWithSpaces(cena) + '' + $("#mena_za").val() + '</div>');
  $("#cena_1").replaceWith('<div id="cena_1" >' + $("#js_celkem").val() + '<br><strong class="cena_konf_red">' + $("#mena_pred").val() + '' + numberWithSpaces(cena) + '' + $("#mena_za").val() + '</strong></div>');
  $("#kosik_cena").replaceWith('<div id="kosik_cena">' + $("#mena_pred").val() + '' + numberWithSpaces(cena) + '' + $("#mena_za").val() + '</div>');

//  } else
//  {
//    $("#cena").hide();
//  }
}

function deaktivace_vyberu(krok, vyber, vsechny_kody = null)
{
  $('#kod_' + krok).val($('#kod_' + krok).val().replace('_' + $('input[name="' + krok + '_' + vyber + '"]:checked').val(), ""));
  $('input[name="' + krok + '_' + vyber + '"]').prop("disabled", true);
  $('input[name="' + krok + '_' + vyber + '"]').prop('checked', false);
  $('#vybrano_nadpis_' + krok + '_' + vyber).empty();
  $('#vybrano_nadpis_' + krok + '_' + vyber).parent('h4').find('.dostupnost').remove();
  $('input[name="' + krok + '_' + vyber + '"]').parent('label').parent().find('.ceny_plus').empty();
  $('input[name="' + krok + '_' + vyber + '"]').parent('label').parent().find('.dostupnost').remove();
  $('input[name="' + krok + '_' + vyber + '"]').parent('label').parent().find('.cena_od').remove();
  $('input[name="' + krok + '_' + vyber + '"]').parent('label').parent('div').addClass("color_div_nohover");
  $('input[name="' + krok + '_' + vyber + '"]').parent('label').parent('div').removeClass("color_div_vyb");

  $('#bar_vybery_nevybrano_' + krok + '_' + vyber).show();
  $('#bar_vybery_vybrano_' + krok + '_' + vyber).hide();
  zmen_cenu($('#cena_krok_' + krok).val(), 0);
  $('#cena_krok_' + krok).val('0');
  $('#kod_' + krok + '_' + vyber).val('');

  if (vsechny_kody !== null)
  {
    if (vsechny_kody.indexOf("_atyp") >= 0) {
    } else
    {
      $("#rozmer_kom").val('');
      $("#rozmer_kom_vl").val('');
      $(".rozmer_vlozeny_vlastni_br").remove();
      $(".rozmer_vlozeny_vlastni").remove();
      $("#zmena_velikosti").slideUp("slow", function () {

      });
//      $("#zmena_velikosti").removeAttr('style');
    }
  } else {
    $("#rozmer_kom").val('');
    $("#rozmer_kom_vl").val('');
    $(".rozmer_vlozeny_vlastni").remove();
    $(".rozmer_vlozeny_vlastni_br").remove();
    $("#zmena_velikosti").slideUp("slow", function () {

    });
//    $("#zmena_velikosti").removeAttr('style');
}
}



function bar_seda()
{
  $(".bar").each(function (index) {
    var sekce_barva = parseFloat($("#sekce").val()) + 1;
    if (sekce_barva > $("#bar_" + index).attr("data-id"))
    {
      $("#bar_" + index).addClass('bar_vyb');
      $("#bar_" + index).removeClass('bar_n');

    } else if (!$("#bar_" + index).hasClass("bar_vyb"))
    {
      $("#bar_" + index).addClass('bar_n');
    }

    if (/*$('body').width() <= 1000*/ window.matchMedia('(max-width: 1000px)').matches && (sekce_barva - 1) == $("#bar_" + index).attr("data-id"))
    {
      $("#bar_" + index + " p").css({"color": "#00aa00"});
      $('.tel_vypis_bar_p').html($("#bar_" + index).attr("data-nazev"));
      $('.closed_tel').hide();
      if (index == 0)
      {
        $('#zpet_tel').hide();
        $('.tel_vypis_bar').css({"width": "100%"});
        $('.tel').show();
      } else
      {
        $('.tel').hide();
        $('#zpet_tel').show();
        $('.tel_vypis_bar').css({"width": "calc(74% - 1px)"});
      }
    } else if (/*$('body').width() <= 1000*/ window.matchMedia('(max-width: 1000px)').matches)
    {
      $("#bar_" + index + " p").css({"color": "black"});
    }
    else
    {
      $("#bar_" + index + " p").removeAttr('style');
      $('#progress_produkt').removeAttr('style');
      $('#zpet_tel').hide();
      $('.tel').hide();
    }

  });



  document.title = $("#url_title").val() + "/" + $("#bar_" + $("#sekce").val()).attr("data-url");
  var url_ga = $("#url_def").val() + "/" + $("#bar_" + $("#sekce").val()).attr("data-url") + "/" + $("#after_url").val();
  window.history.pushState({"html": $("#bar_" + $("#sekce").val()).attr("data-url"), "pageTitle": $("#url_title").val() + "/" + $("#bar_" + $("#sekce").val()).attr("data-url")}, "", url_ga);

  console.log("2: " + url_ga);
  //gtag('config', 'UA-46865024-8', {'page_path': url_ga});

}
$(document).on('click', '#eshop_obrazek_slider', function () {
//  alert('asd');
  $("#zvetsit").click();
});
$(document).scroll(function () {
  checkOffset();
}); 
 
function vypis_souhrnu_prubezne() {
  var html = prislusko = '';
  if($('#kod_obr').val() !== '')
  {  
    $.each($('#kod_obr').val().split(':'), function (key_krok, kod_kroku) {
      var kod_produktu = kod_kroku.split('_');
      
      if(typeof $('#' + kod_kroku) !== 'undefined' && ($('#' + kod_kroku).is(':checked') || $('#' + kod_kroku).is(':disabled')))
      {
          var kod_kroku_element = $('#' + kod_kroku);
          var krok = kod_kroku_element.attr('name').split('_')[0];
          var prvek = kod_kroku_element.attr('name').split('_')[1];

          if(kod_kroku_element.attr('data-krok') === '2' && kod_kroku_element.attr('data-typ') === 'prislusenstvi')
          {
            prislusko += '<div class="souhrn_konf" onclick="change_sekce(' + krok +','+ prvek + ');">';
            prislusko += '<div class="upravit_krok" onclick="change_sekce(' + krok +','+ prvek + ');" data-id="' + krok + '"><div><p><img src="/images/svg/016-pencil.svg"></p></div><p>' + $('#js_upravit').val() + '</p></div><div><p>';
            prislusko += ''+ kod_kroku_element.attr('data-name') + ' ';
            if (kod_kroku_element.attr('data-img') !== '') prislusko += "</p></div><div><p><img src='" + kod_kroku_element.attr('data-img') + "'>";
            prislusko += '</p><div class="js_odpocet_' + krok + ' js_odpocetvse"></div></div>';
            if (kod_kroku_element.parent('label').find('.dostupnost').length) prislusko += kod_kroku_element.parent('label').find('.dostupnost')[0].outerHTML;
            prislusko += '</div>';
          }
          else
          {
            var nazev_extra_konec = nazev_extra_obr = nazev_extra_zacatek = nazev_extra_dodani = '';
            if(kod_kroku_element.parent('label').find(".select_sluzba").length)
            {
              $.each(kod_kroku_element.parent('label').find(".select_sluzba"), function (key_param, value_param) {
                var selectet_option = $(this).find(":selected");
                if(selectet_option.attr('data-produkt') === 'true')
                {
                  nazev_extra_zacatek = ''+selectet_option.attr('data-name')+'<br>';
                  if (selectet_option.attr('data-img') !== '') nazev_extra_obr = "</p></div><div><p><img src='" + selectet_option.attr('data-img') + "'>";
                  if (selectet_option.attr('data-dostupnost') !== '')nazev_extra_dodani = selectet_option.attr('data-dostupnost');
                }
                else
                {
                  nazev_extra_konec += ', '+selectet_option.attr('data-name');
                }
              });
            }
            html += '<div class="souhrn_konf" onclick="change_sekce(' + krok +','+ prvek + ');">';
            html += '<div class="upravit_krok" onclick="change_sekce(' + krok +','+ prvek + ');" data-id="' + krok + '"><div><p><img src="/images/svg/016-pencil.svg"></p></div><p>' + $('#js_upravit').val() + '</p></div><div><p>';
            html += nazev_extra_zacatek+''+ kod_kroku_element.attr('data-name') + ''+ nazev_extra_konec;
            if(nazev_extra_obr !== ''){html += nazev_extra_obr;}else{ if(kod_kroku_element.attr('data-img') !== '') html += "</p></div><div><p><img src='" + kod_kroku_element.attr('data-img') + "'>";}
            html += '</p><div class="js_odpocet_' + krok + ' js_odpocetvse"></div></div>';
            if(nazev_extra_dodani !== ''){html += nazev_extra_dodani;}else{if (kod_kroku_element.parent('label').find('.dostupnost').length) html += kod_kroku_element.parent('label').find('.dostupnost')[0].outerHTML;}
            html += '</div>';
          }
      }
      else
      {
        $.each(kod_produktu, function (key_kod, kod) {
          if(typeof $('#' + kod) !== 'undefined' && $('#' + kod).is(':checked'))
          {
            var kod_kroku_element = $('#' + kod);
            var krok = kod_kroku_element.attr('name').split('_')[0];

            var isLastElement = key_kod === kod_produktu.length -1;
            if(key_kod === 1)
            {
              html += '<div class="souhrn_konf" onclick="change_sekce(' + krok +');">';
              html += '<div class="upravit_krok" onclick="change_sekce(' + krok +');" data-id="' + krok + '"><div><p><img src="/images/svg/016-pencil.svg"></p></div><p>' + $('#js_upravit').val() + '</p></div><div><p>';
            }
            if(isLastElement)
            {
              if (kod_kroku_element.attr('data-img') !== '')html += "</p></div><div><p><img src='" + kod_kroku_element.attr('data-img') + "'>";
              html += '</p><div class="js_odpocet_' + krok + ' js_odpocetvse"></div></div>';
              if (kod_kroku_element.parent('label').find('.dostupnost').length) html += kod_kroku_element.parent('label').find('.dostupnost')[0].outerHTML;
              html += '</div>';
            }
            else
            {
              if (kod_kroku_element.val().indexOf("atyp") >= 0)html += ''+ $("#rozmer_kom_vl").val().replace('×', ' × ') + ' cm';          
              else html += ''+ kod_kroku_element.attr('data-name') + ' ';
            }
          }     
        });
      }
    });
    if (html)
    {
      $(".souhrn_produkt").empty();
      $(".souhrn_produkt").append(html+prislusko);
    }
  }
}

$(document).on('click', '.ui-widget-overlay', function () {
  $("div:ui-dialog:visible").dialog("close");
  $('body').css('overflow', '');
});


//funkce pro pohyb stolu v konfigurátoru je na PC
function checkOffset() {
  if (/*$('body').width() > 1000*/ window.matchMedia('(min-width: 1001px)').matches )
  {
    if($('#scrolable_konf').length && $('#eshop_popis').length)
    {
      if ($('#scrolable_konf').offset().top + $('#scrolable_konf').height() >= $('#eshop_popis').offset().top)
      {
        if ($('#eshop_popis').offset().top - $('#scrolable_konf').height() > 10)
        {
          $('#scrolable_konf').css('top', $('#eshop_popis').offset().top - $('#scrolable_konf').height());
          $('#scrolable_konf').css('position', 'relative');


        } else
        {
          $('#scrolable_konf').css('position', 'relative'); // restore when you scroll up
          $("#scrolable_konf").css('top', '');
        }
      }
      if ($(document).scrollTop() <= $('#scrolable_konf').offset().top)
      {
        $('#scrolable_konf').css('position', 'fixed'); // restore when you scroll up
        $("#scrolable_konf").css('top', '');

      }
    }
    if($('.spodni_lista').length && $('#eshop_popis').length)
    {  
      if ($('.spodni_lista').offset().top + $('.spodni_lista').height() >= $('#eshop_popis').offset().top)
      {
        if ($('.spodni_lista').offset().top - $('.spodni_lista').height() > 10)
        {
          $('.spodni_lista').css('top', $('#eshop_popis').offset().top - $('.spodni_lista').height());
          $(".spodni_lista").css('right', '0');
          $('.spodni_lista').css('position', 'absolute');

        } else
        {
          $('.spodni_lista').css('position', 'fixed'); // restore when you scroll up
          $(".spodni_lista").css('top', '');
        }
      }
      if ($(document).scrollTop() <= $('.spodni_lista').offset().top)
      {
        $('.spodni_lista').css('position', 'fixed'); // restore when you scroll up
        $(".spodni_lista").css('top', '');

      }
    }
  } else if (/*$('body').width() <= 1000*/window.matchMedia('(max-width: 1000px)').matches)
  {
    $("#scrolable_konf").removeAttr('style');
    return false; // následují část kodu nefunguje na safari na iOs 16 - skáče konfigurátor
    if ($('#tel_progres').length)
    {
      if($(window).width()*1.3 <= $(window).height())
      {  
        if ($('#tel_progres').offset().top <= $(document).scrollTop())
        {
          $('#konfigurator_udaje').css('margin-top', $('#scrolable_konf').height());
          $('#scrolable_konf').css('position', 'fixed');
          $("#scrolable_konf").css('top', '0');
          $('#scrolable_konf').css('z-index', '102');
          $('#logo_produkt').hide();
          $('#tel_progres').css('margin-top', '0');
          $('#eshop_obrazek_img').css('width', '50%');
          $('.tel').hide();
        }
        else if($(document).scrollTop() > 0);
        {
          $('#konfigurator_udaje').css('margin-top', $('#scrolable_konf').height());
          $('#scrolable_konf').css('position', 'fixed');
          $("#scrolable_konf").css('top', '0');
          $('#scrolable_konf').css('z-index', '102');
          $('#logo_produkt').hide();
          $('#tel_progres').css('margin-top', '0');
          $('#eshop_obrazek_img').css('width', '50%');
          $('.tel').hide();
        }
        if ($(document).scrollTop() <= 0)
        {
          if ($('#sekce').val() == '0')
            $('.tel').show();

          $('#konfigurator_udaje').attr('style', "");
          $('#scrolable_konf').attr('style', "");
          $('#tel_progres').attr('style', "");
          $('#eshop_obrazek_img').css('width', '88%');
          $('#logo_produkt').show();
        }
      }
      else
      {
        if ($('#sekce').val() == '0')
            $('.tel').show();

          $('#konfigurator_udaje').attr('style', "");
          $('#scrolable_konf').attr('style', "");
          $('#tel_progres').attr('style', "");
          $('#eshop_obrazek_img').css('width', '88%');
          $('#logo_produkt').show();
        
      }
    }
//    $("#scrolable_konf").css('top', '');
//    $('#scrolable_konf').css('margin-left', '');
  }

}

function dodani_vypis()
{
  var kody = VratKodStolu();

  if (kody.produkt)
  {
    var kontrola_sluzby = '';
    var select_sluzba = '';
    var select_sluzba = [];
    $.each($("[data-typproduktu=sluzby]"), function (key, value) {
      if (kontrola_sluzby !== '')kontrola_sluzby += ';';
      if($(value).parent('label').find(".select_sluzba").length)
      {
        $.each($(value).parent('label').find(".select_sluzba"), function (key_param, value_param) {
          $.each($(value_param).find('option'), function (key_sluzby, value_sluzby) {
            if(jQuery.inArray($(value_sluzby).val(), select_sluzba) === -1)
            {
              select_sluzba.push($(value_sluzby).val());
            }
          });
        });
      }    
      else kontrola_sluzby += $(value).val();
    });
    if(select_sluzba)kontrola_sluzby += ';'+select_sluzba.join(';');
    
    $.ajax({
      url: '/rsadmin/_funkce/eshop_dostupnost_produkty.php',
      type: "GET",
      dataType: "html",
      cache: false,
      data: {kod_produktu: kody.produkt, typ: 6, kategorie: $('#js_kategorie').val(), kod_prislusenstvi: kody.prislusenstvi, velikost_desky: kody.velikost, sluby_kontrola: kontrola_sluzby},
      success: function (aData) {
        var sklad_class = '';
        $('#lista_dodani').empty();
        var result = JSON.parse(aData);
        if (!result || !result.text)
          return;

        $('#lista_dodani').empty();
        if (result.sklad > 0)
          sklad_class = 'dostupnost';
        else
          sklad_class = 'dostupnost oranzova';

        $('#lista_dodani').append("<span class='" + sklad_class + "'><p>" + result.text + "</p></span>");
        if(result.cena_sluzby)
        {
          $.each(result.cena_sluzby, function (key_d, value_d) {
            if($("[data-option="+key_d+"]").length > 0)
            {
              $.each($("[data-option="+key_d+"]"), function (key_sluzby, value_sluzby) {
                var parent_option = $('#'+$(value_sluzby).attr('data-produktpuv'));
                if(parent_option.parent('label').parent('div').hasClass("color_div_vyb") && $(value_sluzby).is(':selected'))
                {
                  zmen_cenu(parent_option.attr('data-cena'), value_d.cena);
                  $(value_sluzby).attr('data-cena',value_d.cena);
                  parent_option.attr('data-cena', value_d.cena);
                  var znamenko = '';
                  if(value_d.cena >= 0 )znamenko = '+ ';
                  parent_option.parent('label').find(".text_box_mal").html(znamenko+$("#mena_pred").val() + '' + numberWithSpaces(value_d.cena) + '' + $("#mena_za").val());
                  $('#cena_krok_'+parent_option.attr('name')).val(value_d.cena);
                }
                else if($(value_sluzby).parent('.select_sluzba').find("option:first").val() === key_d && !parent_option.parent('label').parent('div').hasClass("color_div_vyb"))
                {
                  var znamenko = '';
                  if(value_d.cena >= 0 )znamenko = '+ ';
                  parent_option.parent('label').find(".text_box_mal").html(znamenko+$("#mena_pred").val() + '' + numberWithSpaces(value_d.cena) + '' + $("#mena_za").val());
                  $(value_sluzby).attr('data-cena',value_d.cena);
                }
                else
                {
                  $(value_sluzby).attr('data-cena',value_d.cena);
                }      
              });
            }
            else
            {
              if($('#' + key_d).parent('label').parent('div').hasClass("color_div_vyb"))
              { 
                  zmen_cenu($('#' + key_d).attr('data-cena'), value_d.cena);
                  $('#' + key_d).attr('data-cena',value_d.cena);
                  var znamenko = '';
                  if(value_d.cena >= 0 )znamenko = '+ ';
                  $('#' + key_d).parent('label').find(".text_box_mal").html(znamenko+$("#mena_pred").val() + '' + numberWithSpaces(value_d.cena) + '' + $("#mena_za").val());
                  $('#cena_krok_'+$('#' + key_d).attr('name')).val(value_d.cena);
              }
              else
              {
                  $('#' + key_d).attr('data-cena',value_d.cena);
                  var znamenko = '';
                  if(value_d.cena >= 0 )znamenko = '+ ';
                  $('#' + key_d).parent('label').find(".text_box_mal").html(znamenko+$("#mena_pred").val() + '' + numberWithSpaces(value_d.cena) + '' + $("#mena_za").val());

              }
            }            
        });
        }
      }
    });
  }
}

function upravcenypodlevybraneho(krok, vyber, hodnota)
{
  if (krok && vyber && hodnota)
  {
    var kod_prod = $('#kod_' + krok).val();
    $.ajax({
      url: '/rsadmin/_funkce/eshop_dostupnost_produkty.php',
      type: "GET",
      dataType: "html",
      cache: false,
      data: {kod_produktu: kod_prod, aktual: hodnota, krok: krok, vyber: vyber, typ: 7, kategorie: $('#js_kategorie').val()},
      success: function (aData) {
        var result = JSON.parse(aData);
        $('.ceny_plus').empty();
        $.each(result, function (key_d, value_d) {
          if (key_d != 'atyp')
          {
            $('#' + key_d).parent('label').find('.ceny_plus').append('<p>' + value_d + '</p>');
          }
        });
      }
    });
  }
}

function vyber_vybrany(id)
{
//  $.each($('#js_array').val().split(','), function (key_k, value) {
//       var vybery = value.split('_');
//    if ($('#' + id).attr("data-krok") == vybery[0])
//       {
//      if ($('#kod_' + vybery[0] + '_' + vybery[1]).val() != $('#' + id).val() && $('#' + vybery[0] + '_' + vybery[1]).val() != $('#kod_' + vybery[0] + '_' + vybery[1]).val())
//          {
//        $('#' + vybery[0] + '_' + vybery[1] + '_none').prop('checked', true);
//          }
//       }
//  });
//  $('#' + id).prop("disabled", false);
//  $('#' + $('#' + id).attr("data-krok")).parent('label').parent('div').hide();
//  $('#' + $('#' + id).attr("data-krok")).parent('label').parent('div').removeClass("color_div_vyb");
  if ($('#' + id).val() === 'home_assembly')
  {
    if ($("#psc_sestavit_hod").val() === '')
    {
      $("#zmena_sestaveni").slideDown("slow", function () {

      });
      $("#zmena_sestaveni").css({"display": "table-row"});
      $('#pridat_' + id).addClass('odebrat_label_ses');
      return false;
    } else if ($("#open_sestaveni").val() == '0')
    {
      $("#zmena_sestaveni").slideDown("slow", function () {

      });
      $("#zmena_sestaveni").css({"display": "table-row"});
      $('#pridat_' + id).addClass('odebrat_label_ses');
    } else
    {
      $("#zmena_sestaveni").slideUp("slow", function () {

      });
      $("#zmena_sestaveni").css({"display": "none"});
      $('#pridat_' + id).removeClass('odebrat_label_ses');
    }

  } else
  {
    $("#zmena_sestaveni").slideUp("slow", function () {

    });
    $("#zmena_sestaveni").css({"display": "none"});
    $('#pridat_' + id).removeClass('odebrat_label_ses');
  }
  if (/*$('body').width() > 1000*/ window.matchMedia('(min-width: 1001px)').matches)
    $("#open_sestaveni").val('0');


  $('#chyba_sestaveni').hide();
  $('#pridat_' + id).hide();
  $('#odebrat_' + id).show();
  $('#pridat_dialog_' + id).hide();
  $('#odebrat_dialog_' + id).show();
  $('#' + id).click();
//  $('#' + id).prop("disabled", true);
//  $('#' + id).parent('label').parent('div').addClass('color_div_vyb');
//   aktivace_tlacika_pokracovat($('#' + id).attr("data-krok"));
//  $(".chyba").hide();

}
function vyber_odebrat(id)
{
  $('#vyber_select_' + $('#' + id).attr("name") + ' input[type="radio"]').prop('checked', false);
  $('#vyber_select_' + $('#' + id).attr("name") + ' input[type="radio"]').parent('label').parent('div').removeClass("color_div_vyb");
  $('#bar_vybery_nevybrano_' + $('#' + id).attr("name")).show();
  $('#bar_vybery_vybrano_' + $('#' + id).attr("name")).hide();
  $('#vybrano_nadpis_' + $('#' + id).attr("name")).empty();
  $('#kod_' + $('#' + id).attr("name")).val('');
//  $('#cena_krok_' + $('#' + id).attr("name")).val('0');//bez toho NaN při odebrání

  zmen_cenu($('#cena_krok_' + $('#' + id).attr("name")).val(), 0);
  $('#cena_krok_' + $('#' + id).attr("name")).val('0');
//    cgangeimg(slider_bx);
//  $('#' + id).prop("disabled", true);
//  $('#' + id).prop('checked', false);
//  $('#' + id).parent('label').parent('div').removeClass("color_div_vyb");
  $('#pridat_' + id).show();
  $('#odebrat_' + id).hide();
  $('#pridat_dialog_' + id).show();
  $('#odebrat_dialog_' + id).hide();
  if ($('#' + id).val() === 'home_assembly')
  {
    $("#psc_sestavit_hod").val('');
    $("#open_sestaveni").val('0');
    $("#pcs_sestaveni").val('');
  }
  dodani_vypis();
}

$(document).keypress(
        function (event) {
          if (event.which == '13') {
            event.preventDefault();
          }
        });
        
        
function scaleCanvas(typ)
{
  var input_width = null;
  var input_height = null;
  if(typ === 'input')
  {
    input_width = $('#width');
    input_height = $('#height');
  }
  else if(typ === 'range')
  {
    input_width = $('#canvasscale_width');
    input_height = $('#canvasscale_height');
  }
  
  var width = parseFloat(input_width.val());
  var width_min = parseFloat(input_width.attr('min'));
  var width_max = parseFloat(input_width.attr('max'));
  var height = parseFloat(input_height.val());
  var height_min = parseFloat(input_height.attr('min'));
  var height_max = parseFloat(input_height.attr('max'));

  if (height < height_min || height > height_max)
  {
    input_height.val(height_min);
    
    if(typ === 'input')$('#canvasscale_height').val(Math.round(parseFloat($('#height').val())));
    else if(typ === 'range')$('#height').val(Math.round(parseFloat($('#canvasscale_height').val())));
    resizeCanvas();
    
  } else if (width < width_min || width > width_max)
  {
    input_width.val(width_min);
    if(typ === 'input')$('#canvasscale_width').val(Math.round(parseFloat($('#width').val())));
    else if(typ === 'range')$('#width').val(Math.round(parseFloat($('#canvasscale_width').val())));
    resizeCanvas();
    
  }
  if (width >= width_min && height >= height_min && width <= width_max && height <= height_max)
  {
    if(typ === 'input')
    {
      $('#canvasscale_width').val(Math.round(parseFloat($('#width').val())));
      $('#canvasscale_height').val(Math.round(parseFloat($('#height').val())));
    }
    else if(typ === 'range')
    {
      $('#width').val(Math.round(parseFloat($('#canvasscale_width').val())));
      $('#height').val(Math.round(parseFloat($('#canvasscale_height').val())));
    }
    resizeCanvas();
  }
}

function resizeCanvas()
{
  $(".canvas_div").show();
  $("#canvas_zobrazeni").show();
  var canvas = document.getElementById("canvas_zobrazeni");
  var ctx = canvas.getContext("2d");

  var height = document.getElementById("height").value;
  var width = document.getElementById("width").value;

  var sirka_obrazku = $("#eshop_obrazek_img").width();
  var vyska_obrazku = $("#eshop_obrazek_img").height();

  var w_pomer = ((sirka_obrazku / (200 / 100)) / 100);
  var h_pomer = ((vyska_obrazku / (60 * 11 / 100)) / 100);

  width = (parseFloat(width) + parseFloat(height * 0.5)) * parseFloat(w_pomer);
  height = height * h_pomer;

  height = height * 0.6;

  canvas.width = width;
  canvas.height = height;

  ctx.clearRect(0, 0, canvas.width, canvas.height);
  ctx.beginPath();
  ctx.moveTo(width, 0);

  ctx.lineTo(width, height);
  ctx.lineTo(0, height);
  ctx.lineTo(0, 0);

  ctx.moveTo(width, 0);
  ctx.fill();
  ctx.stroke();
}

function poradiVybery()
{
  var vyberpozice = null;
  $('.dalsi_vybery').each(function (vyber) {
    vyberpozice = parseFloat($(this).css('order'));
    if (/*$('body').width() <= 1000*/ window.matchMedia('(max-width: 1000px)').matches)
    {
      var pozice = 0;
      if (vyberpozice > 0)
        pozice = Math.ceil(vyberpozice / 2.0) * 2;
      else if (vyberpozice < 0)
        pozice = Math.floor(vyberpozice / 2.0) * 2;
      else
        pozice = 2;
    } else
    {
      var pozice = 0;
      if (vyberpozice > 0)
        pozice = Math.ceil(vyberpozice / 3.0) * 3;
      else if (vyberpozice < 0)
        pozice = Math.floor(vyberpozice / 3.0) * 3;
      else
        pozice = 3;
    }
    $(this).css('order',pozice+1);
  });

}

function sdileni_ulozeny_funkce(typ)
{
  if ($('.sdilet_ulozit_konf').length > 0)
  {

    $('*[data-typ="ulozeno"]').css( "display", "none" );
    $('*[data-typ="kopirovano"]').css( "display", "none" );
    $('#sdilet_ulozit_konf_dialog').find('.chyba_sec').css( "display", "none" );
    if(typ === 'ulozit')
    {   
      if(preskocit_na_souhrn_kontrola())
      {
        if(return_url_konf_sdileni())
        {  
          setCookie('save_konfigurator', return_url_konf_sdileni(),180);
          $('*[data-typ="ulozeno"]').css( "display", "flex" );
          $('.nacist_konf').show();
        }
        else{
          $('#sdilet_ulozit_konf_dialog').find('.chyba_sec').css( "display", "flex" );
        }
      }
    }
    else if(typ === 'nacist')
    {
      if(getCookie('save_konfigurator'))preset = getCookie('save_konfigurator');
      else preset = getCookie('save_konfigurator_auto');
      if(preset !== '')
      {
        window.location.href = preset;
      }
    }
    else if(typ === 'kopirovat')
    {
      if(preskocit_na_souhrn_kontrola())
      {
        if(return_url_konf_sdileni())
        {  
          $('#odkaz_na_konf_ulozit').val(return_url_konf_sdileni());
          copyToClipboard('odkaz_na_konf_ulozit');
          $('*[data-typ="kopirovano"]').css( "display", "flex" );
        }
      }
    }
    else if(typ === 'muze_nacist')
    {
      if($('#kod_obr').val() === '' && getCookie('save_konfigurator_skryt') !== 'true')
      {  
        var preset = '';
        if(getCookie('save_konfigurator'))preset = getCookie('save_konfigurator');
        else if(getCookie('save_konfigurator_auto'))preset = getCookie('save_konfigurator_auto');
        if(preset !== '')
        {
          if(preset.indexOf("k1") >= 0)
          {
            $('.nacist_konf').hide();
            sdileni_ulozeny();
            
            $('body').css('overflow', 'hidden');
            $("html,body").animate({ scrollTop: 0 });
            $("#sdilet_ulozit_konf_dialog_preset").dialog({
              resizable: true,
              dialogClass: 'dialog_sdilet_ulozit',
              width: '80%',
              modal: true,
              closeText: "",
              beforeClose: function () {
                $('body').css('overflow', '');
                $('*[data-typ="ulozeno"]').css( "display", "none" );
                $('*[data-typ="kopirovano"]').css( "display", "none" );
                $('#sdilet_ulozit_konf_dialog').find('.chyba_sec').css( "display", "none" );
              },
              buttons: {
                "Zavřít": function () {
                  $('body').css('overflow', '');
                  $(this).dialog("close");
                }
              }
            });
            if (/*$('body').width() > 1000*/ window.matchMedia('(min-width: 1001px)').matches)
            {
              
              var kod_obrazek = '';
              var rozmer = '';
              $.each(preset.split('/'), function (key, value) {
                if(value.indexOf("k1") >= 0 && value !=='')
                {

                  $.each(value.split(':'), function (key, kody) {
                    if(kody.indexOf("_atyp") >= 0 && kody !=='')
                    {
                      kod_obrazek = kod_obrazek + kody.split('-')[0];
                      rozmer = kody.split('-')[1];
                    }
                    else if(kody.indexOf("home_assembly") >= 0 && kody !=='')
                    {
                      kod_obrazek = kod_obrazek + kody.split('-')[0];
                    }
                    else
                    {
                      kod_obrazek = kod_obrazek + kody;
                    }
                    if(kod_obrazek)kod_obrazek = kod_obrazek + ':';
                  });
                }
              });
              $.ajax({
                url: '/rsadmin/_funkce/eshop_konfigurator_obr.php',
                type: "GET",
                dataType: "html",
                cache: false,
                async: false,
                data: {obr: kod_obrazek, url: 'true', vl: rozmer},
                success: function (aData)
                {
                  if ($('.sdilet_ulozit_img_preset').length > 0)$(".sdilet_ulozit_img_preset").attr("src", aData);
                }
              });
            }
          }
        }
      }
    }
  }
}

function return_url_konf_sdileni()
{
    var krok = -1;
    var produkty_kod = '';
    $.each($('#js_array').val().split(','), function (key, value) {
      var vybery = value.split('_');
        if (vybery[2] === 'produkt')
        {          
          if(jQuery.inArray("0", kontrola_kroku(vybery[0])) === -1)
          {
            if ($("#kod_" + vybery[0]).val().length > 2 && krok !== vybery[0])
            {
              krok = vybery[0];
              if (produkty_kod !== '')
                produkty_kod = produkty_kod + ':';
              produkty_kod = produkty_kod + $('#kod_' + vybery[0]).val();
              if($('#kod_' + vybery[0]).val().indexOf("_atyp") >= 0)
              {
                produkty_kod = produkty_kod + '-'+ $("#rozmer_kom_vl").val().replace('×', 'x');
              }
            }
          }
        } else if (vybery[2] === 'prislusenstvi' && $('#kod_' + vybery[0] + '_' + vybery[1]).val())
        {
          if (produkty_kod !== '')
            produkty_kod = produkty_kod + ':';
          produkty_kod = produkty_kod + $('#kod_' + vybery[0] + '_' + vybery[1]).val();
          if($('#kod_' + vybery[0] + '_' + vybery[1]).val() === 'home_assembly')
          {
            produkty_kod = produkty_kod + '-'+ $("#psc_sestavit_hod").val();
          }
          if($('#'+$('#kod_' + vybery[0] + '_' + vybery[1]).val()).parent('label').find(".select_sluzba").length)
          {
            $.each($('#'+$('#kod_' + vybery[0] + '_' + vybery[1]).val()).parent('label').find(".select_sluzba"), function (key_param, value_param) {
              produkty_kod = produkty_kod + '-'+ $(this).find(":selected").val();
            });
          }
        }     
    });
    if(produkty_kod !== ''){
      var url_def = '';
      $.each($("#url_def").val().split('/'), function (key, value) {
        if(value.indexOf("k1") < 0 && value !=='')
        {
          url_def = url_def + value;
          if(key === 0)url_def = url_def + '//'; 
          else url_def = url_def + '/'; 
        }
      });
  
    return url_def + produkty_kod + "/" + $("#bar_" + $("#sekce").val()).attr("data-url") + "/"  + $("#after_url").val();
    }
    return false;
}

function sdileni_ulozeny()
{
  if ($('.sdilet_ulozit_konf').length > 0)
  {
    $('.sdilet_ulozit_konf').hide();
    $('.nacist_konf').hide();
    if(preskocit_na_souhrn_kontrola()){
      $('.sdilet_ulozit_konf').show();
      $('.ulozit_konf').show();
      $('.generovat_odkaz').show();
      if(preskocit_na_souhrn_kontrola(false))setCookie('save_konfigurator_auto', return_url_konf_sdileni(),180);
    }
    else
    {
      $('.ulozit_konf').hide();
      $('.generovat_odkaz').hide();
    }
    if(getCookie('save_konfigurator'))
    {
      $('.sdilet_ulozit_konf').show();
      $('.nacist_konf').show();
    }
    if(getCookie('save_konfigurator') || getCookie('save_konfigurator_auto'))
    {
      $('.nacist_konf_pop').show();
    }
   
  }
}
function preskocit_na_souhrn()
{
  if ($('.do_kosiku').length > 0)
  {
    $('.do_kosiku').hide();
    
    if(preskocit_na_souhrn_kontrola())$('.do_kosiku').show();
  }
}
function preskocit_na_souhrn_kontrola(nova_kontrola = true)
{
    var kontrola = [];
    var kontrola_next = [];
    var next_krok = 0;
    var krok = parseInt($('#sekce').val());
    if($('#js_last_krok').val() === $('#sekce').val())
    {
      return true;
    }
    $.each($('#js_array').val().split(','), function (key_k, value_k) {
      var vybery_k = value_k.split('_');
      if (parseInt(vybery_k[0]) === krok)
      {
        next_krok = parseInt(vybery_k[0]) + 1;
        if (!$("#vyber_select_" + vybery_k[0] + '_' + vybery_k[1]).hasClass("kat_hidden_konf"))
        {
          if ($('input[name="' + vybery_k[0] + '_' + vybery_k[1] + '"]').is(':checked') || $('.nevybrano_' + vybery_k[0] + '_' + vybery_k[1] + '').val() === 'true' || $("#skiped_" + vybery_k[0]).val() === 'true')
          {
            kontrola.push("1");
          } 
          else
          {
            kontrola.push("0");
          }
        }
      }
    });    
    if ($('#preskoc_pokud_' + next_krok).length > 0)
    {
      var vybery_skip = $('#preskoc_pokud_' + next_krok).val().split(':');
      if (jQuery.inArray("" + $('#kod_' + $('#sekce').val()).val(), vybery_skip) === -1)
      {
        kontrola_next = kontrola_na_souhrn(next_krok); 
      }
    }
    else
    {
      kontrola_next = kontrola_na_souhrn(next_krok);
    }
    if(nova_kontrola)
    {
      if($("#button_preskocit_" + next_krok).length > 0)kontrola_next.splice(0,kontrola_next.length);
      if($("#button_preskocit_" + krok).length > 0)kontrola.splice(0,kontrola.length);
    }
    if (jQuery.inArray("0", kontrola) === -1 && jQuery.inArray("0", kontrola_next) === -1)
    {
      return true;
    }  
  return false;
}

function kontrola_na_souhrn(next_krok)
{
  var kontrola = [];
  $.each($('#js_array').val().split(','), function (key_k, value_k) {
    var vybery_sec = value_k.split('_');
    if (parseInt(vybery_sec[0]) === parseInt(next_krok) && vybery_sec[2] === "produkt")
    {
      var id_kat = $('#kat_desky_' + vybery_sec[0]).val();
      if(id_kat || $("#skiped_" + vybery_sec[0]).val() === 'true')
      {
        if (jQuery.inArray(id_kat, $('input[name="' + vybery_sec[0] + '_' + vybery_sec[1] + '"]').attr('data-kategorie').split(',')) !== -1 || $("#skiped_" + vybery_sec[0]).val() === 'true')
        {
          if ($('input[name="' + vybery_sec[0] + '_' + vybery_sec[1] + '"]').is(':checked') || $('.nevybrano_' + vybery_sec[0] + '_' + vybery_sec[1] + '').val() === 'true' || $("#skiped_" + vybery_sec[0]).val() === 'true')
          {
            kontrola.push("1");
          } 
          else
          {
            kontrola.push("0");
          }
        } 
      }
      else
      {
        kontrola.push("0");
      }
    }      
  });
  return kontrola;
}

function kontrola_kroku(next_krok)
{
  var kontrola = [];
  $.each($('#js_array').val().split(','), function (key_k, value_k) {
    var vybery_sec = value_k.split('_');
    if (parseInt(vybery_sec[0]) === parseInt(next_krok) && vybery_sec[2] === "produkt")
    {
      if (!$("#vyber_select_" + vybery_sec[0] + '_' + vybery_sec[1]).hasClass("kat_hidden_konf"))
      {
        if ($('input[name="' + vybery_sec[0] + '_' + vybery_sec[1] + '"]').is(':checked') || $('.nevybrano_' + vybery_sec[0] + '_' + vybery_sec[1] + '').val() === 'true' || $("#skiped_" + vybery_sec[0]).val() === 'true')
        {
          kontrola.push("1");
        } 
        else
        {
          kontrola.push("0");
        }
      }   
    }      
  });
  return kontrola;
}


function nacti_doporucene()
{
  //nastavení proměnných 
  var pocet_zobrazenych = 3;
  var def_prislusko = '', prislusko_vyzkousene = '', html_vypis = '';
  var def_sluzby = '', sluzby_vyzkousene = '', html_vypis_sluzby = '';
  
  const mozne_prislusko = [], mozne_prislusko_pov = [], mozne_prislusko_zak = [], prislusko_config = [], prislusko_cookie = [], prislusko_vypsat = [];
  const mozne_sluzby = [], mozne_sluzby_pov = [], mozne_sluzby_zak = [], sluzby_config = [], sluzby_cookie = [], sluzby_vypsat = [];
  //načtený produktů z adminu
  if ($('#js_prislusko_souhrn').length > 0 && $('#js_prislusko_souhrn').val() !== '')
  {
    def_prislusko = $('#js_prislusko_souhrn').val().split(',');
  }
  //načtený produktů z Cookie na co človek kliknul
  if (getCookie('prislusko_vyzkousene'))
  {
    prislusko_vyzkousene = getCookie('prislusko_vyzkousene').split('|');
  }
  
  //načtený produktů z adminu služby
  if ($('#js_sluzby_souhrn').length > 0 && $('#js_sluzby_souhrn').val() !== '')
  {
    def_sluzby = $('#js_sluzby_souhrn').val().split(',');
  }
  //načtený produktů z Cookie na co človek kliknul
  if (getCookie('sluzby_vyzkousene'))
  {
    sluzby_vyzkousene = getCookie('sluzby_vyzkousene').split('|');
  }
  
  //produkty ze souhrnu
  var vybrane_prislusko = $('#konf_produkty').val().split('|');

  
  //projdu všechno příslušenství a zjistím které se nachází i nenachází v souhrnu 
  $.each($('#js_array').val().split(','), function (key_k, value_k) {
    var vybery_sec = value_k.split('_');
    if (vybery_sec[2] === "prislusenstvi" && $('input[name="' + vybery_sec[0] + '_' + vybery_sec[1] + '"]').attr('data-typproduktu') === 'prislusenstvi')
    {
      $('input[name="' + vybery_sec[0] + '_' + vybery_sec[1] + '"]').each(function (key_d_input, value_input) {
          //pokud je produkt zobrazen a není ve výpisu je možno ho přidat 
          if ($('#vyber_select_' + vybery_sec[0] + '_' + vybery_sec[1] + '').css('display') !== 'none' && jQuery.inArray($(value_input).val(), vybrane_prislusko) === -1 )
          {
            if(jQuery.inArray($(value_input).attr('name'), mozne_prislusko_pov) === -1)
            {
              mozne_prislusko_pov.push($(value_input).attr('name'));
            }
          }
          //pokud se ale jeden z produktů výberu náchází v souhrnu přidám do speciálního array abych ho pak nebral v potaz
          else
          {
            if(jQuery.inArray($(value_input).attr('name'), mozne_prislusko_zak) === -1)
            {
              mozne_prislusko_zak.push($(value_input).attr('name'));
            }
          }
          //potřebuji si ukládat jak id_kroku tak id_výběru + kod produktu na který se kliklo nebo nastavilo abych načetl správný obrázek 
          //uložím si produkty které člověk zkoušel 
          if(prislusko_vyzkousene)
          {
            if(jQuery.inArray($(value_input).val(), prislusko_vyzkousene) !== -1 && typeof prislusko_cookie[$(value_input).attr('name')] === 'undefined')
            {
              prislusko_cookie[$(value_input).attr('name')] = $(value_input).val();
            }
          }
          //uložím si produkty které jsou nastavené z adminu
          if(def_prislusko)
          {
            if(jQuery.inArray($(value_input).val(), def_prislusko) !== -1 && typeof prislusko_config[$(value_input).attr('name')] === 'undefined')
            {
              prislusko_config[$(value_input).attr('name')] = $(value_input).val();
            }
          }
      });
    }
    else if(vybery_sec[2] === "prislusenstvi" && $('input[name="' + vybery_sec[0] + '_' + vybery_sec[1] + '"]').attr('data-typproduktu') === 'sluzby')
    {
      $('input[name="' + vybery_sec[0] + '_' + vybery_sec[1] + '"]').each(function (key_d_input, value_input) {
          //pokud je produkt zobrazen a není ve výpisu je možno ho přidat 
          if ($('#vyber_select_' + vybery_sec[0] + '_' + vybery_sec[1] + '').css('display') !== 'none' && $('#konf_produkty').val().indexOf($(value_input).val()) < 0)
          {
            if(jQuery.inArray($(value_input).attr('name'), mozne_sluzby_pov) === -1)
            {
              mozne_sluzby_pov.push($(value_input).attr('name'));
            }
          }
          //pokud se ale jeden z produktů výberu náchází v souhrnu přidám do speciálního array abych ho pak nebral v potaz
          else
          {
            if(jQuery.inArray($(value_input).attr('name'), mozne_sluzby_zak) === -1)
            {
              mozne_sluzby_zak.push($(value_input).attr('name'));
            }
          }
          //potřebuji si ukládat jak id_kroku tak id_výběru + kod produktu na který se kliklo nebo nastavilo abych načetl správný obrázek 
          //uložím si produkty které člověk zkoušel 
          if(sluzby_vyzkousene)
          {
            if(jQuery.inArray($(value_input).val(), sluzby_vyzkousene) !== -1 && typeof sluzby_cookie[$(value_input).attr('name')] === 'undefined')
            {
              sluzby_cookie[$(value_input).attr('name')] = $(value_input).val();
            }
          }
          //uložím si produkty které jsou nastavené z adminu
          if(def_sluzby)
          {
            if(jQuery.inArray($(value_input).val(), def_sluzby) !== -1 && typeof sluzby_config[$(value_input).attr('name')] === 'undefined')
            {
              sluzby_config[$(value_input).attr('name')] = $(value_input).val();
            }
          }
      });
    }
  });
  if(count(prislusko_config) >= 1 || count(prislusko_cookie) >= 1 || count(mozne_prislusko_pov) >= 1)
  {
    //porovná možné příslušenství se zakázaným(zakázané je to co ve v souhrnu) 
    $.each(mozne_prislusko_pov, function (key_k, value_k) {
      if(jQuery.inArray(value_k, mozne_prislusko_zak) === -1)
      {
        mozne_prislusko.push(value_k);
      }
    });
    //pokud je něco v cookie tak si produkt uložím  
    if(prislusko_cookie)
    {
      $.each(mozne_prislusko, function (key_k, value_k) {
        if(typeof prislusko_cookie[value_k] !== 'undefined')
        {          
          if(count(prislusko_vypsat) < pocet_zobrazenych)prislusko_vypsat[value_k] = prislusko_cookie[value_k];
        }
      });
    } 
    //pokud je něco v config tak si produkt uložím a zárověn není max počet zobrazených
    if(prislusko_config && count(prislusko_vypsat) < pocet_zobrazenych)
    {
      $.each(def_prislusko, function (key_kk, value_kk) {
        $.each(mozne_prislusko, function (key_k, value_k) {
          if(typeof prislusko_config[value_k] !== 'undefined' && typeof prislusko_vypsat[value_k] === 'undefined' && value_kk === prislusko_config[value_k])
          {          
            if(count(prislusko_vypsat) < pocet_zobrazenych)prislusko_vypsat[value_k] = prislusko_config[value_k];
          }
        });  
      });
    }
    //pokud není max počet zobrazených tak vezmu nějaké co zbývají
    if(count(prislusko_vypsat) < pocet_zobrazenych)
    {
      $.each(mozne_prislusko, function (key_k, value_k) {
        if(typeof prislusko_vypsat[value_k] === 'undefined' && typeof prislusko_vypsat[value_k] === 'undefined')
        {
          if(count(prislusko_vypsat) < pocet_zobrazenych)prislusko_vypsat[value_k] = '';
        }
      });    
    }
  }
  if(count(sluzby_config) >= 1 || count(sluzby_cookie) >= 1 || count(mozne_sluzby_pov) >= 1)
  {
    //porovná možné příslušenství se zakázaným(zakázané je to co ve v souhrnu) 
    $.each(mozne_sluzby_pov, function (key_k, value_k) {
      if(jQuery.inArray(value_k, mozne_sluzby_zak) === -1)
      {
        mozne_sluzby.push(value_k);
      }
    });
    //pokud je něco v cookie tak si produkt uložím  
    if(sluzby_cookie)
    {
      $.each(mozne_sluzby, function (key_k, value_k) {
        if(typeof sluzby_cookie[value_k] !== 'undefined')
        {
          if(count(sluzby_vypsat) < pocet_zobrazenych)sluzby_vypsat[value_k] = sluzby_cookie[value_k];
        }
      });
    }
    //pokud je něco v config tak si produkt uložím a zárověn není max počet zobrazených
    if(sluzby_config && count(sluzby_vypsat) < pocet_zobrazenych)
    {
      $.each(def_sluzby, function (key_kk, value_kk) {
        $.each(mozne_sluzby, function (key_k, value_k) {
          if(typeof sluzby_config[value_k] !== 'undefined' && typeof sluzby_vypsat[value_k] === 'undefined' && value_kk === sluzby_config[value_k])
          {
            if(count(sluzby_vypsat) < pocet_zobrazenych)sluzby_vypsat[value_k] = sluzby_config[value_k];
          }
        }); 
      });
    } 
    //pokud není max počet zobrazených tak vezmu nějaké co zbývají
    if(count(sluzby_vypsat) < pocet_zobrazenych)
    {
      $.each(mozne_sluzby, function (key_k, value_k) {
        if(typeof sluzby_vypsat[value_k] === 'undefined' && typeof sluzby_vypsat[value_k] === 'undefined')
        {
          if(count(sluzby_vypsat) < pocet_zobrazenych)sluzby_vypsat[value_k] = '';
        }
      });    
    }
  }
  //pokud je co vypsat tak vypíšu pokud ne tak celý blok skryji
  if(count(prislusko_vypsat) >= 1 || count(sluzby_vypsat) >= 1)
  {
    $('.souhrn_konf_doporuceni').show();
    
    if(count(prislusko_vypsat) >= 1)
    {
      $.each(Object.assign({}, prislusko_vypsat), function (key_k, value_k) {
          $('input[name="' + key_k + '"]').each(function (key_d_input, value_input) {
            if($(value_input).val() === value_k || value_k === '')
            {
              var pozice = $(value_input).attr('name').split('_');
              html_vypis = html_vypis + '<div class="souhrn_konf_produkt" onclick="change_sekce('+pozice[0]+','+pozice[1]+')"><div class="souhrn_konf_produkt_img"><img src="'+$(value_input).attr('data-img')+'"></div><div class="souhrn_konf_produkt_nazev">'+$("#vyber_select_" + $(value_input).attr('name')).find('h4').html()+'</div></div>';
              return false;
            }
          });      
      });
      html_vypis = html_vypis + '<div class="souhrn_konf_produkt" onclick="change_sekce(2);"><div class="souhrn_konf_produkt_img"><img src="/images/dalsi_produkty.png"/></div><div class="souhrn_konf_produkt_nazev">'+$('#js_prislusko_souhrn_dalsi').val()+'</div></div>';
      $('.souhrn_konf_doporuceni_produkty').html(html_vypis);
    }
    if(count(sluzby_vypsat) >= 1)
    {
      $.each(Object.assign({}, sluzby_vypsat), function (key_k, value_k) {
          $('input[name="' + key_k + '"]').each(function (key_d_input, value_input) {
            if($(value_input).val() === value_k || value_k === '')
            {
              var pozice = $(value_input).attr('name').split('_');
              html_vypis_sluzby = html_vypis_sluzby + '<div class="souhrn_konf_produkt" onclick="change_sekce('+pozice[0]+','+pozice[1]+')"><div class="souhrn_konf_produkt_img"><img src="'+$(value_input).attr('data-img')+'"></div><div class="souhrn_konf_produkt_nazev">'+$(value_input).attr('data-name')+'</div></div>';
              return false;
            }
          });      
      });
      html_vypis_sluzby = html_vypis_sluzby + '<div class="souhrn_konf_produkt" onclick="change_sekce(3);"><div class="souhrn_konf_produkt_img"><img src="/images/dalsi_produkty.png"/></div><div class="souhrn_konf_produkt_nazev">'+$('#js_sluzby_souhrn_dalsi').val()+'</div></div>';
      $('.souhrn_konf_doporuceni_produkty_sluzby').html(html_vypis_sluzby);
    }
  }
  else $('.souhrn_konf_doporuceni').hide(); 
}

$(document).click(function (evt) {

  if (evt.target.className == "iframe_youtube")
    return;

  $('.iframe_youtube').each(function (i) {
    if ($(this).attr('type') == 'video/mp4')
    {
      if ($(this).is(":hidden"))
      {
        $(this).parent('video').get(0).pause();
      }
    } else
    {
      if ($(this).attr('data-src') != $(this).attr('src') && $(this).is(":visible")) {
        $(this).prop('src', $(this).attr('data-src'));

      } else if ($(this).is(":hidden"))
      {
        $(this).prop('src', 'about:blank');
      }
    }
  });
});
function setMezeraProSluzbyDesek() {
  var prvek_pozice = -1;
  $('.mezera_deskysluzby').remove();
  var vyber = 0;
  $.each($('.sluzby_desky_blok').find(".color_div_prislusko"), function (key_param, value_param) {
    if($(value_param).css('display') !== 'none')
    {   
      vyber++; 
      if (/*$('body').width() > 1000*/ window.matchMedia('(min-width: 1001px)').matches)
      {
        if(vyber % 3 === 0 )
        {
          $(value_param).after( "<div class='mezera mezera_deskysluzby'></div>" );
        }
      }
      else
      {
        if(vyber % 2 === 0 )
        {
          $(value_param).after( "<div class='mezera mezera_deskysluzby'></div>" );
        }
      }
    }
  });
}
function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  let expires = "expires="+ d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i <ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}
function copyToClipboard(element) {
  var copyText = document.getElementById(element);
  copyText.select();
  navigator.clipboard.writeText(copyText.value);
}
function count(array){
    var c = 0;
    for(i in array)
        if(array[i] != undefined)
            c++;
    return c;
}

function VratKodStolu()
{
  var produkty_pridat = produkty_pridat_param = prislusenstvi_pridat = prislusenstvi_sluzby = '';
  var vel = '';
  var jenjednou = -1;
  var kontrola = 0;
  $.each($('#js_array').val().split(','), function (key_kosik, value_kosik) {
    var vybery_kosik = value_kosik.split('_');
    if ($("#skiped_" + vybery_kosik[0]).val() === 'true')
    {
    } else
    {
      //vložení do košíku
      if (vybery_kosik[2] === 'produkt')
      {
        if ($('#kod_' + vybery_kosik[0]).val() !== '' && jenjednou !== vybery_kosik[0])
        {
          kontrola = 0;
          $.each($('#js_array').val().split(','), function (key_k, value_k) {
            var vybery_k = value_k.split('_');
            if (vybery_k[2] === 'produkt' && vybery_k[0] === vybery_kosik[0])
            {
              if ($('input[name="' + vybery_k[0] + '_' + vybery_k[1] + '"]').is(':checked'))kontrola = 1;
              else kontrola = 0;
            }
          });
          if(kontrola === 1)
          {  
            jenjednou = vybery_kosik[0];
            if ($('#kod_' + vybery_kosik[0]).val().indexOf("_atyp") >= 0)vel = $("#rozmer_kom_vl").val().replace('×', 'x');;          
            if (produkty_pridat !== '')produkty_pridat = produkty_pridat + ';';
            produkty_pridat_param = produkty_pridat = produkty_pridat + $('#kod_' + vybery_kosik[0]).val();
            if($('#kod_' + vybery_kosik[0]).val().indexOf("_atyp") >= 0)produkty_pridat_param = produkty_pridat_param + '-' + vel;
          }
        }
      } else if (vybery_kosik[2] === 'prislusenstvi')
      {
        if ($('#kod_' + vybery_kosik[0] + '_' + vybery_kosik[1]).val() !== '')
        {
          prislusenstvi = '';
          prislusenstvi = prislusenstvi + $('#kod_' + vybery_kosik[0] + '_' + vybery_kosik[1]).val();
          if($('#'+$('#kod_' + vybery_kosik[0] + '_' + vybery_kosik[1]).val()).parent('label').find(".select_sluzba").length)
          {
            $.each($('#'+$('#kod_' + vybery_kosik[0] + '_' + vybery_kosik[1]).val()).parent('label').find(".select_sluzba"), function (key_param, value_param) {
              prislusenstvi = prislusenstvi + '-'+ $(this).find(":selected").val();
              if($(this).find(":selected").attr('data-produkt') === 'true')prislusenstvi = prislusenstvi + ':true';
            });
          }
          if($('#'+$('#kod_' + vybery_kosik[0] + '_' + vybery_kosik[1]).val()).attr('data-typproduktu') === 'sluzby')
          {
            if (prislusenstvi_sluzby !== '')prislusenstvi_sluzby = prislusenstvi_sluzby + ';';
            prislusenstvi_sluzby = prislusenstvi_sluzby + prislusenstvi;
          }
          else   
          {
            if (prislusenstvi_pridat !== '')prislusenstvi_pridat = prislusenstvi_pridat + ';';
            prislusenstvi_pridat = prislusenstvi_pridat + prislusenstvi;
          }
        }
      }
    }
  });
  
  return {produkt:produkty_pridat, produkt_param:produkty_pridat_param, prislusenstvi:prislusenstvi_pridat, sluzby:prislusenstvi_sluzby, velikost:vel};
}